var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath0, _clipPath1, _clipPath10, _clipPath11, _clipPath12, _clipPath13, _clipPath14, _clipPath15, _clipPath16, _clipPath17, _clipPath18, _clipPath19, _clipPath20, _clipPath21, _clipPath22, _clipPath23, _clipPath24, _clipPath25, _clipPath26, _clipPath27, _clipPath28, _clipPath29, _clipPath30, _clipPath31, _clipPath32, _clipPath33, _clipPath34, _clipPath35, _clipPath36, _clipPath37, _clipPath38, _clipPath39, _clipPath40, _clipPath41, _clipPath42, _clipPath43, _clipPath44, _clipPath45, _clipPath46, _clipPath47, _clipPath48, _clipPath49, _clipPath50, _clipPath51, _clipPath52, _clipPath53, _clipPath54, _clipPath55, _clipPath56, _clipPath57, _clipPath58, _clipPath59, _clipPath60, _clipPath61, _clipPath62, _clipPath63, _clipPath64, _clipPath65, _clipPath66, _clipPath67, _clipPath68, _clipPath69, _clipPath70, _clipPath71, _clipPath72, _clipPath73, _clipPath74, _clipPath75, _clipPath76, _clipPath77, _clipPath78, _clipPath79, _clipPath80, _clipPath81, _clipPath82, _clipPath83, _clipPath84, _clipPath85, _clipPath86, _clipPath87, _clipPath88, _clipPath89, _clipPath90, _clipPath91;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIsoCert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 604.71997,
    height: 604.71997,
    viewBox: "0 0 604.71997 604.71997",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path8"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path10"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path12"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path14"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path16"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path18"
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path20"
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path22"
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path24"
  }))), _clipPath0 || (_clipPath0 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path26"
  }))), _clipPath1 || (_clipPath1 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path28"
  }))), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path30"
  }))), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path32"
  }))), _clipPath12 || (_clipPath12 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path34"
  }))), _clipPath13 || (_clipPath13 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path36"
  }))), _clipPath14 || (_clipPath14 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path38"
  }))), _clipPath15 || (_clipPath15 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path40"
  }))), _clipPath16 || (_clipPath16 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path42"
  }))), _clipPath17 || (_clipPath17 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path44"
  }))), _clipPath18 || (_clipPath18 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path46"
  }))), _clipPath19 || (_clipPath19 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path48"
  }))), _clipPath20 || (_clipPath20 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path50"
  }))), _clipPath21 || (_clipPath21 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path52"
  }))), _clipPath22 || (_clipPath22 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path54"
  }))), _clipPath23 || (_clipPath23 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path56"
  }))), _clipPath24 || (_clipPath24 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path58"
  }))), _clipPath25 || (_clipPath25 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path60"
  }))), _clipPath26 || (_clipPath26 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path62"
  }))), _clipPath27 || (_clipPath27 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path64"
  }))), _clipPath28 || (_clipPath28 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path66"
  }))), _clipPath29 || (_clipPath29 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path68"
  }))), _clipPath30 || (_clipPath30 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path70"
  }))), _clipPath31 || (_clipPath31 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path72"
  }))), _clipPath32 || (_clipPath32 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path74"
  }))), _clipPath33 || (_clipPath33 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath76"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path76"
  }))), _clipPath34 || (_clipPath34 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath78"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path78"
  }))), _clipPath35 || (_clipPath35 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath80"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path80"
  }))), _clipPath36 || (_clipPath36 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath82"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path82"
  }))), _clipPath37 || (_clipPath37 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath84"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path84"
  }))), _clipPath38 || (_clipPath38 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath86"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path86"
  }))), _clipPath39 || (_clipPath39 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path88"
  }))), _clipPath40 || (_clipPath40 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath90"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path90"
  }))), _clipPath41 || (_clipPath41 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path92"
  }))), _clipPath42 || (_clipPath42 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path94"
  }))), _clipPath43 || (_clipPath43 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path96"
  }))), _clipPath44 || (_clipPath44 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath98"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path98"
  }))), _clipPath45 || (_clipPath45 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path100"
  }))), _clipPath46 || (_clipPath46 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath102"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path102"
  }))), _clipPath47 || (_clipPath47 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path104"
  }))), _clipPath48 || (_clipPath48 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath106"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path106"
  }))), _clipPath49 || (_clipPath49 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath108"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path108"
  }))), _clipPath50 || (_clipPath50 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath110"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path110"
  }))), _clipPath51 || (_clipPath51 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath112"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path112"
  }))), _clipPath52 || (_clipPath52 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath114"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path114"
  }))), _clipPath53 || (_clipPath53 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath116"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path116"
  }))), _clipPath54 || (_clipPath54 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath118"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path118"
  }))), _clipPath55 || (_clipPath55 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath120"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path120"
  }))), _clipPath56 || (_clipPath56 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath122"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path122"
  }))), _clipPath57 || (_clipPath57 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath124"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path124"
  }))), _clipPath58 || (_clipPath58 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath126"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path126"
  }))), _clipPath59 || (_clipPath59 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath128"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path128"
  }))), _clipPath60 || (_clipPath60 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath130"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path130"
  }))), _clipPath61 || (_clipPath61 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath132"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path132"
  }))), _clipPath62 || (_clipPath62 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath134"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path134"
  }))), _clipPath63 || (_clipPath63 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath136"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path136"
  }))), _clipPath64 || (_clipPath64 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath138"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4412,4313.65 H 2393.25 V 1689.24 H 4412 Z",
    clipRule: "evenodd",
    id: "path138"
  }))), _clipPath65 || (_clipPath65 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath141"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 106,1318 V 4437 H 2333 V 1318 Z",
    clipRule: "evenodd",
    id: "path141"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 106.422,
    y1: 189.411,
    x2: -14.384,
    y2: 282.97501,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(10)",
    spreadMethod: "pad",
    id: "linearGradient146"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#0d121e"
    },
    offset: 0,
    id: "stop142"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#0e1320"
    },
    offset: 0.3,
    id: "stop143"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#203663"
    },
    offset: 0.5,
    id: "stop144"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#233e73"
    },
    offset: 0.6,
    id: "stop145"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#254179"
    },
    offset: 1,
    id: "stop146"
  })), _clipPath66 || (_clipPath66 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath146"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 106,1318 V 4437 H 2333 V 1318 Z",
    clipRule: "evenodd",
    id: "path146"
  }))), _clipPath67 || (_clipPath67 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath148"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 106,1318 V 4437 H 2333 V 1318 Z",
    clipRule: "evenodd",
    id: "path148"
  }))), _clipPath68 || (_clipPath68 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath150"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 106,1318 V 4437 H 2333 V 1318 Z",
    clipRule: "evenodd",
    id: "path150"
  }))), _clipPath69 || (_clipPath69 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath152"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 106,1318 V 4437 H 2333 V 1318 Z",
    clipRule: "evenodd",
    id: "path152"
  }))), _clipPath70 || (_clipPath70 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath154"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 106,1318 V 4437 H 2333 V 1318 Z",
    clipRule: "evenodd",
    id: "path154"
  }))), _clipPath71 || (_clipPath71 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath156"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 106,1318 V 4437 H 2333 V 1318 Z",
    clipRule: "evenodd",
    id: "path156"
  }))), _clipPath72 || (_clipPath72 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath158"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 106,1318 V 4437 H 2333 V 1318 Z",
    clipRule: "evenodd",
    id: "path158"
  }))), _clipPath73 || (_clipPath73 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath160"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 106,1318 V 4437 H 2333 V 1318 Z",
    clipRule: "evenodd",
    id: "path160"
  }))), _clipPath74 || (_clipPath74 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath162"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 106,1318 V 4437 H 2333 V 1318 Z",
    clipRule: "evenodd",
    id: "path162"
  }))), _clipPath75 || (_clipPath75 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath164"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 106,1318 V 4437 H 2333 V 1318 Z",
    clipRule: "evenodd",
    id: "path164"
  }))), _clipPath76 || (_clipPath76 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath166"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 106,1318 V 4437 H 2333 V 1318 Z",
    clipRule: "evenodd",
    id: "path166"
  }))), _clipPath77 || (_clipPath77 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 106,1318 V 4437 H 2333 V 1318 Z",
    clipRule: "evenodd",
    id: "path168"
  }))), _clipPath78 || (_clipPath78 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath170"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 106,1318 V 4437 H 2333 V 1318 Z",
    clipRule: "evenodd",
    id: "path170"
  }))), _clipPath79 || (_clipPath79 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath172"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 106,1318 V 4437 H 2333 V 1318 Z",
    clipRule: "evenodd",
    id: "path172"
  }))), _clipPath80 || (_clipPath80 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath174"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 106,1318 V 4437 H 2333 V 1318 Z",
    clipRule: "evenodd",
    id: "path174"
  }))), _clipPath81 || (_clipPath81 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath176"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 106,1318 V 4437 H 2333 V 1318 Z",
    clipRule: "evenodd",
    id: "path176"
  }))), _clipPath82 || (_clipPath82 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath178"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 106,1318 V 4437 H 2333 V 1318 Z",
    clipRule: "evenodd",
    id: "path178"
  }))), _clipPath83 || (_clipPath83 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath180"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 106,1318 V 4437 H 2333 V 1318 Z",
    clipRule: "evenodd",
    id: "path180"
  }))), _clipPath84 || (_clipPath84 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath182"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 106,1318 V 4437 H 2333 V 1318 Z",
    clipRule: "evenodd",
    id: "path182"
  }))), _clipPath85 || (_clipPath85 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath184"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 106,1318 V 4437 H 2333 V 1318 Z",
    clipRule: "evenodd",
    id: "path184"
  }))), _clipPath86 || (_clipPath86 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath186"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 106,1318 V 4437 H 2333 V 1318 Z",
    clipRule: "evenodd",
    id: "path186"
  }))), _clipPath87 || (_clipPath87 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath188"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 106,1318 V 4437 H 2333 V 1318 Z",
    clipRule: "evenodd",
    id: "path188"
  }))), _clipPath88 || (_clipPath88 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath190"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 106,1318 V 4437 H 2333 V 1318 Z",
    clipRule: "evenodd",
    id: "path190"
  }))), _clipPath89 || (_clipPath89 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath192"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 106,1318 V 4437 H 2333 V 1318 Z",
    clipRule: "evenodd",
    id: "path192"
  }))), _clipPath90 || (_clipPath90 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath194"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 106,1318 V 4437 H 2333 V 1318 Z",
    clipRule: "evenodd",
    id: "path194"
  }))), _clipPath91 || (_clipPath91 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath196"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 106,1318 V 4437 H 2333 V 1318 Z",
    clipRule: "evenodd",
    id: "path196"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group-R5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "m 3273.69,1465.61 c 0,-7.11 -1.27,-13.44 -3.81,-18.98 -2.54,-5.54 -6.2,-10.22 -10.98,-14.03 -4.78,-3.81 -10.69,-6.68 -17.71,-8.63 -7.03,-1.95 -15.07,-2.92 -24.12,-2.92 -8.47,0 -16.04,0.89 -22.73,2.66 -6.68,1.78 -12.35,4.41 -17.01,7.88 -4.65,3.47 -8.21,7.74 -10.66,12.82 -2.46,5.08 -3.69,10.87 -3.69,17.39 0,5.16 0.85,9.9 2.54,14.22 1.7,4.32 4.13,8.29 7.3,11.93 3.18,3.64 7.09,7.05 11.75,10.22 4.65,3.18 9.9,6.2 15.74,9.08 -5.08,2.62 -9.56,5.4 -13.46,8.32 -3.89,2.92 -7.19,6.09 -9.9,9.52 -2.71,3.42 -4.76,7.08 -6.16,10.98 -1.39,3.89 -2.09,8.12 -2.09,12.69 0,5.76 1.03,11.15 3.11,16.19 2.07,5.04 5.2,9.42 9.39,13.14 4.19,3.72 9.52,6.66 16,8.82 6.47,2.16 14.03,3.24 22.66,3.24 8.29,0 15.47,-0.99 21.52,-2.98 6.05,-1.99 11.04,-4.7 14.98,-8.13 3.93,-3.43 6.83,-7.47 8.7,-12.12 1.86,-4.66 2.79,-9.65 2.79,-14.98 0,-4.32 -0.7,-8.47 -2.1,-12.44 -1.39,-3.98 -3.45,-7.75 -6.15,-11.3 -2.71,-3.56 -6.03,-6.88 -9.97,-9.97 -3.94,-3.09 -8.44,-5.99 -13.52,-8.7 6.01,-2.96 11.36,-6 16.06,-9.14 4.7,-3.13 8.63,-6.49 11.81,-10.09 3.17,-3.6 5.58,-7.4 7.23,-11.42 1.65,-4.02 2.48,-8.45 2.48,-13.27 z m -27.42,84.3 c 0,3.55 -0.62,6.77 -1.84,9.64 -1.23,2.88 -3.03,5.34 -5.4,7.37 -2.37,2.03 -5.31,3.57 -8.82,4.63 -3.52,1.06 -7.51,1.59 -12,1.59 -9.14,0 -16.06,-2.08 -20.76,-6.22 -4.69,-4.15 -7.04,-9.82 -7.04,-17.01 0,-3.3 0.57,-6.37 1.71,-9.21 1.14,-2.83 2.92,-5.52 5.33,-8.06 2.41,-2.54 5.46,-5.01 9.14,-7.43 3.68,-2.41 8.06,-4.93 13.14,-7.55 8.55,4.4 15.11,9.27 19.68,14.6 4.57,5.33 6.86,11.21 6.86,17.65 z m 5.33,-86.59 c 0,3.9 -0.72,7.43 -2.16,10.6 -1.44,3.18 -3.62,6.14 -6.54,8.89 -2.92,2.75 -6.56,5.42 -10.92,8 -4.35,2.58 -9.41,5.27 -15.17,8.06 -5.33,-2.62 -10.01,-5.25 -14.03,-7.87 -4.02,-2.62 -7.32,-5.33 -9.9,-8.13 -2.58,-2.79 -4.53,-5.73 -5.84,-8.82 -1.31,-3.09 -1.97,-6.49 -1.97,-10.22 0,-8.21 2.82,-14.56 8.45,-19.04 5.63,-4.49 14.03,-6.73 25.2,-6.73 10.83,0 19.02,2.26 24.56,6.79 5.55,4.53 8.32,10.69 8.32,18.47",
    style: {
      fill: "#13100f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3",
    d: "m 3395.94,1432.86 c 0,-1.53 -0.11,-2.88 -0.32,-4.07 -0.21,-1.18 -0.51,-2.18 -0.89,-2.98 -0.38,-0.8 -0.89,-1.4 -1.52,-1.78 -0.64,-0.38 -1.34,-0.57 -2.1,-0.57 h -90.77 c -1.18,0 -2.22,0.15 -3.11,0.44 -0.89,0.3 -1.65,0.79 -2.28,1.46 -0.64,0.68 -1.1,1.66 -1.4,2.92 -0.3,1.27 -0.45,2.84 -0.45,4.7 0,1.69 0.07,3.18 0.2,4.45 0.13,1.27 0.42,2.39 0.85,3.36 0.44,0.97 0.98,1.95 1.64,2.92 0.65,0.97 1.5,2.01 2.55,3.11 l 32.83,33.77 c 7.59,7.79 13.67,14.77 18.25,20.95 4.58,6.18 8.11,11.8 10.6,16.88 2.49,5.08 4.12,9.69 4.91,13.84 0.78,4.15 1.17,8.04 1.17,11.68 0,3.64 -0.61,7.09 -1.83,10.35 -1.22,3.25 -2.99,6.11 -5.31,8.57 -2.31,2.45 -5.21,4.4 -8.71,5.84 -3.49,1.43 -7.51,2.15 -12.05,2.15 -5.33,0 -10.11,-0.72 -14.34,-2.15 -4.24,-1.44 -7.95,-3.01 -11.14,-4.7 -3.19,-1.69 -5.85,-3.26 -7.99,-4.7 -2.14,-1.44 -3.73,-2.16 -4.78,-2.16 -0.61,0 -1.16,0.17 -1.64,0.51 -0.48,0.34 -0.87,0.89 -1.18,1.65 -0.3,0.76 -0.54,1.78 -0.72,3.05 -0.17,1.27 -0.26,2.79 -0.26,4.57 0,1.27 0.04,2.37 0.13,3.3 0.08,0.93 0.23,1.73 0.44,2.41 0.21,0.68 0.49,1.31 0.83,1.9 0.34,0.6 1.01,1.34 2.03,2.23 1.01,0.89 2.77,2.09 5.27,3.61 2.49,1.53 5.63,3.03 9.39,4.51 3.77,1.48 7.92,2.73 12.44,3.75 4.53,1.01 9.29,1.52 14.29,1.52 7.95,0 14.91,-1.12 20.88,-3.36 5.97,-2.25 10.92,-5.32 14.85,-9.21 3.94,-3.89 6.88,-8.42 8.83,-13.58 1.94,-5.16 2.92,-10.67 2.92,-16.51 0,-5.24 -0.47,-10.47 -1.4,-15.67 -0.93,-5.21 -2.9,-10.84 -5.9,-16.89 -3.01,-6.05 -7.35,-12.78 -13.02,-20.19 -5.67,-7.4 -13.2,-15.93 -22.59,-25.58 L 3319.51,1442 h 71.48 c 0.67,0 1.33,-0.19 1.96,-0.58 0.64,-0.38 1.19,-0.95 1.65,-1.71 0.47,-0.76 0.81,-1.71 1.02,-2.86 0.21,-1.14 0.32,-2.47 0.32,-3.99",
    style: {
      fill: "#13100f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4",
    d: "m 3525.8,1465.61 c 0,-7.11 -1.27,-13.44 -3.81,-18.98 -2.54,-5.54 -6.2,-10.22 -10.98,-14.03 -4.78,-3.81 -10.68,-6.68 -17.71,-8.63 -7.02,-1.95 -15.06,-2.92 -24.12,-2.92 -8.46,0 -16.04,0.89 -22.72,2.66 -6.69,1.78 -12.36,4.41 -17.01,7.88 -4.66,3.47 -8.21,7.74 -10.67,12.82 -2.45,5.08 -3.68,10.87 -3.68,17.39 0,5.16 0.85,9.9 2.54,14.22 1.69,4.32 4.12,8.29 7.3,11.93 3.17,3.64 7.09,7.05 11.74,10.22 4.66,3.18 9.9,6.2 15.74,9.08 -5.07,2.62 -9.56,5.4 -13.45,8.32 -3.9,2.92 -7.2,6.09 -9.91,9.52 -2.7,3.42 -4.76,7.08 -6.15,10.98 -1.4,3.89 -2.1,8.12 -2.1,12.69 0,5.76 1.04,11.15 3.11,16.19 2.08,5.04 5.21,9.42 9.4,13.14 4.19,3.72 9.52,6.66 15.99,8.82 6.48,2.16 14.03,3.24 22.66,3.24 8.3,0 15.47,-0.99 21.52,-2.98 6.05,-1.99 11.05,-4.7 14.98,-8.13 3.94,-3.43 6.84,-7.47 8.7,-12.12 1.86,-4.66 2.79,-9.65 2.79,-14.98 0,-4.32 -0.7,-8.47 -2.09,-12.44 -1.4,-3.98 -3.45,-7.75 -6.16,-11.3 -2.71,-3.56 -6.03,-6.88 -9.97,-9.97 -3.93,-3.09 -8.44,-5.99 -13.52,-8.7 6.01,-2.96 11.37,-6 16.06,-9.14 4.7,-3.13 8.64,-6.49 11.81,-10.09 3.17,-3.6 5.59,-7.4 7.24,-11.42 1.65,-4.02 2.47,-8.45 2.47,-13.27 z m -27.42,84.3 c 0,3.55 -0.61,6.77 -1.84,9.64 -1.23,2.88 -3.03,5.34 -5.4,7.37 -2.37,2.03 -5.31,3.57 -8.82,4.63 -3.51,1.06 -7.51,1.59 -12,1.59 -9.14,0 -16.06,-2.08 -20.75,-6.22 -4.7,-4.15 -7.05,-9.82 -7.05,-17.01 0,-3.3 0.57,-6.37 1.72,-9.21 1.14,-2.83 2.92,-5.52 5.33,-8.06 2.41,-2.54 5.46,-5.01 9.14,-7.43 3.68,-2.41 8.06,-4.93 13.14,-7.55 8.55,4.4 15.1,9.27 19.68,14.6 4.57,5.33 6.85,11.21 6.85,17.65 z m 5.33,-86.59 c 0,3.9 -0.72,7.43 -2.16,10.6 -1.43,3.18 -3.61,6.14 -6.53,8.89 -2.92,2.75 -6.56,5.42 -10.92,8 -4.36,2.58 -9.42,5.27 -15.17,8.06 -5.33,-2.62 -10.01,-5.25 -14.03,-7.87 -4.02,-2.62 -7.32,-5.33 -9.9,-8.13 -2.58,-2.79 -4.53,-5.73 -5.84,-8.82 -1.31,-3.09 -1.97,-6.49 -1.97,-10.22 0,-8.21 2.81,-14.56 8.44,-19.04 5.63,-4.49 14.03,-6.73 25.2,-6.73 10.84,0 19.02,2.26 24.57,6.79 5.54,4.53 8.31,10.69 8.31,18.47",
    style: {
      fill: "#13100f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5",
    d: "m 3649.32,1512.07 c 0,-7.11 -0.42,-14.3 -1.27,-21.58 -0.85,-7.28 -2.28,-14.28 -4.32,-21.01 -2.03,-6.73 -4.76,-13.03 -8.18,-18.91 -3.43,-5.89 -7.75,-11.03 -12.95,-15.43 -5.21,-4.4 -11.39,-7.85 -18.54,-10.35 -7.15,-2.49 -15.47,-3.74 -24.94,-3.74 -3.64,0 -7.18,0.23 -10.6,0.7 -3.43,0.46 -6.52,1.03 -9.27,1.71 -2.75,0.68 -5.06,1.4 -6.92,2.16 -1.86,0.76 -3.22,1.52 -4.06,2.28 -0.85,0.77 -1.46,1.8 -1.84,3.11 -0.39,1.32 -0.58,3.07 -0.58,5.27 0,1.86 0.07,3.35 0.19,4.45 0.13,1.1 0.32,1.94 0.58,2.54 0.25,0.59 0.61,0.99 1.07,1.2 0.47,0.21 1.04,0.32 1.72,0.32 0.93,0 2.24,-0.32 3.93,-0.95 1.7,-0.64 3.83,-1.34 6.42,-2.1 2.58,-0.76 5.6,-1.46 9.07,-2.09 3.47,-0.64 7.37,-0.95 11.68,-0.95 8.21,0 15.26,1.58 21.14,4.76 5.88,3.17 10.69,7.42 14.41,12.75 3.72,5.34 6.52,11.51 8.38,18.54 1.86,7.02 2.88,14.43 3.04,22.22 -4.48,-2.63 -9.86,-4.95 -16.12,-6.99 -6.26,-2.03 -13.46,-3.04 -21.58,-3.04 -9.14,0 -16.82,1.25 -23.04,3.74 -6.22,2.5 -11.22,5.91 -14.98,10.22 -3.77,4.32 -6.48,9.44 -8.13,15.36 -1.65,5.93 -2.47,12.4 -2.47,19.43 0,7.28 1.05,14.19 3.17,20.75 2.12,6.56 5.42,12.34 9.9,17.33 4.49,5 10.2,8.97 17.14,11.94 6.94,2.96 15.24,4.44 24.88,4.44 6.86,0 12.93,-0.87 18.22,-2.6 5.29,-1.74 9.88,-4.23 13.78,-7.49 3.89,-3.26 7.19,-7.2 9.9,-11.81 2.71,-4.61 4.89,-9.84 6.54,-15.68 1.65,-5.84 2.83,-12.16 3.55,-18.98 0.72,-6.81 1.08,-13.98 1.08,-21.52 z m -22.22,2.42 c 0,10.83 -0.72,19.95 -2.15,27.35 -1.44,7.41 -3.56,13.4 -6.35,17.97 -2.79,4.57 -6.22,7.87 -10.29,9.9 -4.06,2.03 -8.75,3.05 -14.09,3.05 -5.5,0 -10.2,-1 -14.09,-2.99 -3.89,-1.98 -7.09,-4.65 -9.58,-7.99 -2.5,-3.35 -4.34,-7.13 -5.53,-11.37 -1.18,-4.23 -1.77,-8.59 -1.77,-13.07 0,-5 0.53,-9.57 1.58,-13.71 1.06,-4.15 2.78,-7.66 5.15,-10.54 2.36,-2.88 5.45,-5.1 9.26,-6.67 3.81,-1.56 8.51,-2.34 14.09,-2.34 6.35,0 12.49,0.95 18.41,2.85 5.93,1.91 11.05,4.42 15.36,7.56",
    style: {
      fill: "#13100f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6",
    d: "M 4478.74,4478.74 H 56.6914 V 56.6914 H 4478.74 Z",
    style: {
      fill: "none",
      stroke: "#13100f",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7",
    d: "M 4460.06,1639.33 H 2348.15 V 4346.91 H 4460.06 V 1639.33",
    style: {
      fill: "#2d2b6d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9",
    d: "m 2702.63,2006.22 h -18.79 l -47.92,113.26 H 2635 l -10.09,-134.35 h -22.46 l 12.84,163 H 2646 l 47.46,-116.23 48.38,116.23 h 29.8 l 12.85,-163 h -22.48 l -9.63,135.72 h -0.91 l -48.84,-114.63",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    d: "m 2854.39,2055.51 h 49.97 l -24.53,71.75 h -0.92 z m 74.51,-70.38 -17.66,50.66 h -63.74 l -17.42,-50.66 h -23.62 l 58.47,163 h 29.11 l 58.46,-163 h -23.6",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13",
    d: "m 3075.84,2019.75 h 0.91 v 128.38 h 22.47 v -163 h -25.91 l -70.38,129.3 h -0.92 v -129.3 h -22.46 v 163 h 27.74 l 68.55,-128.38",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15",
    d: "m 3174.18,2055.51 h 49.97 l -24.53,71.75 h -0.91 z m 74.5,-70.38 -17.65,50.66 h -63.74 l -17.42,-50.66 h -23.61 l 58.45,163 h 29.13 l 58.45,-163 h -23.61",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    d: "m 3362.38,1983.07 c -66.48,1.82 -67.86,40.8 -67.86,63.04 v 41.04 c 0,22.23 1.38,63.05 71.53,63.05 18.34,0 35.54,-3.21 46.54,-5.05 v -18.57 c -9.39,1.61 -27.74,4.13 -46.54,4.13 -48.14,0 -49.06,-24.99 -49.06,-43.56 v -41.04 c 0,-18.11 0.68,-42.19 45.39,-43.56 12.61,0 30.49,3.21 39.89,8.26 v 36 h -34.15 v 19.48 h 54.33 v -67.4 c -15.36,-8.95 -35.31,-15.82 -60.07,-15.82",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19",
    d: "m 3458.89,1985.13 v 163 h 99.95 v -19.48 h -77.49 v -53.19 h 69.01 v -19.48 h -69.01 v -51.36 h 79.55 v -19.49 h -102.01",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path21",
    d: "m 3690.89,2006.22 h -18.8 l -47.92,113.26 h -0.91 l -10.09,-134.35 h -22.47 l 12.84,163 h 30.72 l 47.46,-116.23 48.37,116.23 h 29.8 l 12.85,-163 h -22.48 l -9.62,135.72 h -0.92 l -48.83,-114.63",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path23",
    d: "m 3810.31,1985.13 v 163 h 99.95 v -19.48 h -77.49 v -53.19 h 69.01 v -19.48 h -69.01 v -51.36 h 79.56 v -19.49 h -102.02",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path25",
    d: "m 4043.46,2019.75 h 0.91 v 128.38 h 22.47 v -163 h -25.91 l -70.38,129.3 h -0.92 v -129.3 h -22.46 v 163 h 27.74 l 68.55,-128.38",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path27",
    d: "m 4144.31,2128.65 h -49.52 v 19.48 h 121.51 v -19.48 h -49.52 v -143.52 h -22.47 v 143.52",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path29",
    d: "m 2959.03,1912.93 c -22.92,0 -36.68,-3.67 -36.68,-23.15 0,-11.93 7.56,-16.97 23.39,-25.45 l 30.03,-15.36 c 19.26,-9.63 29.11,-19.94 29.11,-43.56 0,-33.01 -22.69,-40.12 -60.75,-40.12 -8.26,0 -30.26,2.06 -47.46,6.42 v 20.4 c 16.29,-5.04 39.2,-7.33 47.46,-7.33 23.84,0 38.29,3.89 38.29,20.63 0,13.76 -5.73,18.79 -17.21,24.54 l -31.85,16.27 c -22.02,11.45 -33.47,20.84 -33.47,44.23 0,35.09 20.63,41.97 59.14,41.97 7.57,0 26.83,-1.15 40.35,-5.04 v -20.18 c -10.32,3.9 -31.63,5.73 -40.35,5.73",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath30)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path31",
    d: "m 3092.45,1841.17 h 0.46 l 45.85,89.18 h 26.14 l -61.44,-111.88 v -51.12 h -22.47 v 51.58 l -61.22,111.42 h 26.15 l 46.53,-89.18",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33",
    d: "m 3240.77,1912.93 c -22.92,0 -36.69,-3.67 -36.69,-23.15 0,-11.93 7.57,-16.97 23.4,-25.45 l 30.03,-15.36 c 19.26,-9.63 29.11,-19.94 29.11,-43.56 0,-33.01 -22.69,-40.12 -60.75,-40.12 -8.26,0 -30.26,2.06 -47.46,6.42 v 20.4 c 16.28,-5.04 39.2,-7.33 47.46,-7.33 23.84,0 38.28,3.89 38.28,20.63 0,13.76 -5.73,18.79 -17.19,24.54 l -31.86,16.27 c -22.02,11.45 -33.47,20.84 -33.47,44.23 0,35.09 20.63,41.97 59.14,41.97 7.57,0 26.82,-1.15 40.35,-5.04 v -20.18 c -10.32,3.9 -31.64,5.73 -40.35,5.73",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path35",
    d: "m 3355.62,1910.87 h -49.51 v 19.48 h 121.5 v -19.48 h -49.51 v -143.52 h -22.48 v 143.52",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path37",
    d: "m 3455.57,1767.35 v 163 h 99.96 v -19.48 h -77.49 v -53.2 h 69 v -19.47 h -69 v -51.36 h 79.55 v -19.49 h -102.02",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path39",
    d: "m 3687.57,1788.44 h -18.8 l -47.92,113.26 h -0.91 l -10.09,-134.35 h -22.46 l 12.82,163 h 30.73 l 47.46,-116.23 48.37,116.23 h 29.81 l 12.83,-163 h -22.46 l -9.63,135.72 h -0.92 l -48.83,-114.63",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath40)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path41",
    d: "m 3861.32,1912.93 c -22.92,0 -36.67,-3.67 -36.67,-23.15 0,-11.93 7.57,-16.97 23.38,-25.45 l 30.02,-15.36 c 19.27,-9.63 29.13,-19.94 29.13,-43.56 0,-33.01 -22.7,-40.12 -60.75,-40.12 -8.25,0 -30.27,2.06 -47.46,6.42 v 20.4 c 16.27,-5.04 39.21,-7.33 47.46,-7.33 23.84,0 38.28,3.89 38.28,20.63 0,13.76 -5.73,18.79 -17.19,24.54 l -31.88,16.27 c -22,11.45 -33.46,20.84 -33.46,44.23 0,35.09 20.63,41.97 59.14,41.97 7.56,0 26.83,-1.15 40.36,-5.04 v -20.18 c -10.32,3.9 -31.64,5.73 -40.36,5.73",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path43",
    d: "m 3275.71,3015.75 c -57.75,45.9 -121.01,85.36 -188.94,116.7 V 2986.5 c 80.8,-55.7 151.8,-124.6 209.84,-203.62 v -0.45 c 52.67,97.56 120.05,192.02 199.93,278.11 63.03,67.94 132.74,128.75 206.21,180.43 v 122.51 c -165,-83.25 -310.68,-206.28 -427.04,-347.73",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path45",
    d: "m 3121.25,3852.84 c 0.84,0.84 1.6,1.77 2.26,2.77 0.65,0.97 1.22,2.03 1.68,3.11 0.44,1.1 0.79,2.24 1.02,3.4 0.23,1.16 0.35,2.35 0.35,3.54 0,1.18 -0.12,2.37 -0.35,3.55 -0.23,1.15 -0.58,2.29 -1.02,3.38 -0.46,1.11 -1.03,2.16 -1.68,3.14 -0.65,1 -1.42,1.93 -2.26,2.75 -0.83,0.83 -1.76,1.59 -2.77,2.25 -0.96,0.65 -2.01,1.23 -3.11,1.67 -1.09,0.47 -2.23,0.82 -3.39,1.04 -2.32,0.47 -4.74,0.47 -7.07,0 -1.17,-0.22 -2.31,-0.57 -3.4,-1.04 -1.09,-0.44 -2.16,-1.02 -3.14,-1.67 -1,-0.66 -1.92,-1.42 -2.77,-2.25 -0.81,-0.82 -1.58,-1.75 -2.23,-2.75 -0.65,-0.98 -1.23,-2.03 -1.67,-3.14 -0.47,-1.09 -0.81,-2.23 -1.05,-3.38 -0.23,-1.18 -0.36,-2.37 -0.36,-3.55 0,-1.19 0.13,-2.38 0.36,-3.54 0.24,-1.16 0.58,-2.3 1.05,-3.4 0.44,-1.08 1.02,-2.14 1.67,-3.11 0.65,-1 1.42,-1.93 2.23,-2.77 0.85,-0.83 1.77,-1.6 2.77,-2.25 0.98,-0.65 2.05,-1.22 3.14,-1.68 1.09,-0.44 2.23,-0.79 3.4,-1.03 1.16,-0.23 2.35,-0.34 3.53,-0.34 4.77,0 9.45,1.93 12.81,5.3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path47",
    d: "m 3101.23,3994.21 c 2.89,-1.68 6.01,-2.47 9.12,-2.47 6.23,0 12.31,3.24 15.68,9.03 5.04,8.64 2.09,19.74 -6.57,24.77 -8.64,5.05 -19.74,2.11 -24.79,-6.57 -5.03,-8.64 -2.08,-19.74 6.56,-24.76",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path49",
    d: "m 3142.54,4029.91 c 4.07,0 8.16,1.37 11.56,4.17 7.7,6.39 8.79,17.81 2.4,25.53 -6.38,7.7 -17.82,8.79 -25.53,2.39 -7.72,-6.4 -8.78,-17.81 -2.41,-25.54 3.6,-4.31 8.77,-6.55 13.98,-6.55",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath50)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path51",
    d: "m 3186.01,4054.45 c 1.98,0 4,0.32 5.95,1.02 9.47,3.28 14.46,13.63 11.17,23.07 -3.29,9.46 -13.63,14.47 -23.08,11.16 -9.45,-3.27 -14.47,-13.63 -11.15,-23.06 2.59,-7.5 9.62,-12.19 17.11,-12.19",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath52)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path53",
    d: "m 3235.27,4062.86 c 10,0.02 18.11,8.15 18.11,18.14 0,10.03 -8.13,18.15 -18.14,18.12 -10.02,0 -18.11,-8.12 -18.11,-18.12 0,-10.02 8.11,-18.14 18.14,-18.14",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path55",
    d: "m 3277.98,4055.05 c 2.08,-0.79 4.25,-1.16 6.37,-1.16 7.31,0 14.23,4.48 16.97,11.74 3.52,9.37 -1.23,19.84 -10.6,23.35 -9.38,3.54 -19.82,-1.21 -23.36,-10.58 -3.51,-9.37 1.24,-19.82 10.62,-23.35",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path57",
    d: "m 3089.48,3945.21 c 1.17,-0.21 2.32,-0.34 3.47,-0.34 8.51,0 16.09,6.03 17.77,14.7 1.91,9.82 -4.51,19.33 -14.35,21.24 -9.84,1.91 -19.35,-4.53 -21.23,-14.35 -1.91,-9.84 4.5,-19.35 14.34,-21.25",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path59",
    d: "m 3095.77,3895.24 c 9.88,1.67 16.51,11.02 14.83,20.89 v 0.02 c -1.67,9.86 -11.02,16.51 -20.88,14.84 -9.89,-1.68 -16.54,-11.05 -14.86,-20.91 1.51,-8.83 9.19,-15.1 17.86,-15.1 1,0 2.03,0.08 3.05,0.26",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath60)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path61",
    d: "m 3321.47,4040.17 c 0.97,-0.66 2.05,-1.23 3.14,-1.68 1.09,-0.47 2.23,-0.79 3.39,-1.02 1.17,-0.26 2.36,-0.38 3.54,-0.38 4.77,0 9.45,1.93 12.81,5.33 3.38,3.38 5.31,8.03 5.31,12.81 0,1.2 -0.12,2.38 -0.35,3.54 -0.23,1.16 -0.58,2.31 -1.02,3.4 -0.46,1.1 -1.03,2.14 -1.68,3.11 -0.65,1 -1.42,1.94 -2.26,2.77 -4.2,4.21 -10.46,6.14 -16.35,4.96 -1.16,-0.23 -2.3,-0.58 -3.39,-1.02 -1.09,-0.47 -2.17,-1.03 -3.14,-1.69 -1.01,-0.66 -1.91,-1.41 -2.75,-2.25 -0.83,-0.83 -1.6,-1.77 -2.26,-2.77 -0.64,-0.97 -1.2,-2.01 -1.66,-3.11 -0.44,-1.09 -0.79,-2.24 -1.03,-3.4 -0.25,-1.16 -0.38,-2.34 -0.38,-3.54 0,-4.76 1.96,-9.43 5.33,-12.81 0.84,-0.84 1.74,-1.6 2.75,-2.25",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path63",
    d: "m 3716.58,3872.59 c -0.47,1.09 -1.02,2.16 -1.68,3.14 -0.67,1 -1.4,1.93 -2.24,2.74 -0.84,0.84 -1.78,1.6 -2.77,2.26 -0.99,0.67 -2.03,1.23 -3.12,1.67 -1.09,0.47 -2.24,0.82 -3.4,1.05 -2.33,0.46 -4.75,0.46 -7.09,0 -1.14,-0.23 -2.28,-0.58 -3.37,-1.05 -1.12,-0.44 -2.17,-1 -3.15,-1.67 -0.99,-0.66 -1.93,-1.42 -2.77,-2.26 -0.82,-0.81 -1.58,-1.74 -2.22,-2.74 -0.67,-0.98 -1.24,-2.05 -1.68,-3.14 -0.47,-1.09 -0.82,-2.23 -1.02,-3.37 -0.27,-1.19 -0.37,-2.38 -0.37,-3.56 0,-1.19 0.1,-2.38 0.37,-3.54 0.2,-1.16 0.55,-2.3 1.02,-3.4 0.44,-1.08 1.01,-2.14 1.68,-3.11 0.64,-1 1.41,-1.93 2.25,-2.77 3.37,-3.37 8.02,-5.3 12.82,-5.3 1.16,0 2.37,0.11 3.53,0.35 1.16,0.23 2.31,0.58 3.4,1.02 1.09,0.46 2.13,1.03 3.12,1.68 0.99,0.65 1.93,1.41 2.77,2.25 0.84,0.84 1.57,1.77 2.24,2.77 0.66,0.97 1.21,2.03 1.68,3.11 0.44,1.1 0.79,2.24 1.03,3.4 0.23,1.16 0.35,2.35 0.35,3.54 0,1.18 -0.12,2.37 -0.35,3.56 -0.24,1.14 -0.59,2.28 -1.03,3.37",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath64)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path65",
    d: "m 3616.29,4055.47 c 1.98,-0.7 3.98,-1.02 5.96,-1.02 7.51,0 14.52,4.69 17.12,12.19 3.3,9.43 -1.7,19.79 -11.14,23.06 -9.47,3.31 -19.8,-1.7 -23.11,-11.16 -3.3,-9.44 1.71,-19.79 11.17,-23.07",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath66)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path67",
    d: "m 3654.16,4034.07 c 3.39,-2.79 7.49,-4.16 11.56,-4.16 5.2,0 10.39,2.23 13.97,6.58 6.4,7.7 5.3,19.11 -2.38,25.51 -7.73,6.4 -19.15,5.31 -25.55,-2.39 -6.37,-7.72 -5.31,-19.14 2.4,-25.54",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path69",
    d: "m 3682.22,4000.77 c 3.39,-5.79 9.46,-9.03 15.71,-9.03 3.09,0 6.23,0.79 9.09,2.47 8.65,5.02 11.59,16.12 6.56,24.79 -5.05,8.65 -16.14,11.58 -24.79,6.54 -8.65,-5.03 -11.58,-16.13 -6.57,-24.77",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath70)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path71",
    d: "m 3573,4062.86 c 10.01,0 18.12,8.12 18.14,18.14 0,10 -8.1,18.12 -18.1,18.15 H 3573 c -9.99,0 -18.11,-8.12 -18.14,-18.15 0,-9.99 8.12,-18.12 18.14,-18.14",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path73",
    d: "m 3711.88,3980.81 c -9.81,-1.91 -16.25,-11.42 -14.34,-21.24 1.67,-8.67 9.25,-14.7 17.76,-14.7 1.14,0 2.31,0.13 3.47,0.34 9.84,1.9 16.26,11.41 14.37,21.25 -1.91,9.82 -11.42,16.26 -21.26,14.35",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath74)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path75",
    d: "m 3718.56,3930.99 c -9.89,1.67 -19.24,-4.98 -20.91,-14.86 -1.67,-9.87 4.98,-19.22 14.83,-20.89 1.04,-0.18 2.06,-0.28 3.08,-0.28 8.67,0 16.35,6.29 17.84,15.12 1.67,9.89 -4.98,19.23 -14.84,20.91",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath76)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path77",
    d: "m 3523.9,4053.89 c 2.15,0 4.28,0.37 6.4,1.16 9.38,3.52 14.1,13.98 10.6,23.35 -3.55,9.37 -13.99,14.12 -23.37,10.58 -9.37,-3.51 -14.1,-13.98 -10.57,-23.35 2.71,-7.26 9.63,-11.74 16.94,-11.74",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath78)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path79",
    d: "m 3459.99,4048.31 c 0.45,-1.1 1.01,-2.16 1.67,-3.15 0.66,-1 1.4,-1.91 2.24,-2.74 0.84,-0.84 1.78,-1.6 2.77,-2.25 0.98,-0.66 2.03,-1.23 3.11,-1.68 1.09,-0.44 2.27,-0.79 3.4,-1.02 1.19,-0.26 2.37,-0.38 3.57,-0.38 4.76,0 9.43,1.96 12.82,5.33 0.82,0.83 1.57,1.74 2.25,2.74 0.64,0.99 1.2,2.05 1.65,3.15 0.46,1.09 0.81,2.22 1.04,3.39 0.23,1.16 0.35,2.35 0.35,3.53 0,4.78 -1.93,9.45 -5.29,12.82 -4.23,4.21 -10.47,6.14 -16.39,4.96 -1.13,-0.23 -2.28,-0.58 -3.4,-1.02 -1.08,-0.47 -2.13,-1.03 -3.11,-1.69 -0.99,-0.66 -1.93,-1.41 -2.77,-2.25 -3.37,-3.37 -5.3,-8.04 -5.3,-12.82 0,-1.18 0.11,-2.37 0.34,-3.53 0.24,-1.17 0.6,-2.3 1.05,-3.39",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath80)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path81",
    d: "m 3628.96,3727.69 c -6.36,0.98 -12.68,2.86 -18.79,5.77 -33.73,16.03 -45.65,51.81 -32.39,77.81 3.38,6.39 11.3,9.05 17.89,5.91 6.79,-3.22 9.68,-11.33 6.45,-18.12 -1.49,-3.12 -4,-5.4 -6.95,-6.65 11.81,-3.57 24.77,1.9 30.22,13.38 6.02,12.66 0.64,27.8 -12.02,33.82 -11.45,5.45 -24.9,1.54 -31.83,-8.6 l -0.24,0.07 c 4.39,6.82 8.15,15.99 10.48,26.4 5.27,23.58 1.17,44.59 -9.16,47.13 l 0.01,0.05 c -10.46,2.37 -23.31,-14.91 -28.69,-38.62 -2.36,-10.39 -2.9,-20.29 -1.88,-28.34 h -0.25 c -1.88,12.16 -12.36,21.47 -25.05,21.47 -14.02,0 -25.38,-11.35 -25.38,-25.38 0,-12.71 9.35,-23.21 21.55,-25.06 -2.12,2.4 -3.42,5.54 -3.42,8.99 0,7.52 6.09,13.6 13.6,13.6 7.25,0 13.22,-5.67 13.63,-12.83 0.93,-29.25 -25.24,-56.55 -62.67,-56.55 -33.4,0 -61.11,24.23 -66.57,56.07 27.35,-3.84 50.99,-19.21 65.82,-41.09 v 105.49 c -14.79,-21.81 -38.37,-37.17 -65.66,-41.04 3.18,16.98 12.7,31.72 26.04,41.66 v 105.48 c 34.46,3.94 67.94,13 99.94,27.16 20.69,8 43.26,7.57 63.65,-1.24 20.6,-8.92 36.51,-25.33 44.77,-46.2 8.26,-20.88 7.9,-43.73 -1.02,-64.37 l -5.86,-13.65 c -6.56,-15.15 -6.85,-31.74 -0.83,-46.74 4.22,-10.51 11.25,-19.5 20.37,-26.21 z m -304.76,34.25 c -37.44,0 -63.6,27.3 -62.67,56.55 0.4,7.15 6.38,12.83 13.63,12.83 7.51,0 13.6,-6.08 13.6,-13.6 0,-3.45 -1.3,-6.59 -3.42,-8.99 12.2,1.85 21.56,12.35 21.56,25.06 0,14.03 -11.38,25.38 -25.4,25.38 -12.67,0 -23.16,-9.31 -25.04,-21.47 h -0.26 c 1.03,8.05 0.49,17.95 -1.86,28.34 -5.39,23.71 -18.24,40.99 -28.7,38.62 l 0.01,-0.05 c -10.33,-2.54 -14.44,-23.55 -9.16,-47.13 2.32,-10.41 6.1,-19.58 10.48,-26.4 l -0.25,-0.07 c -6.92,10.14 -20.37,14.05 -31.82,8.6 -12.67,-6.02 -18.05,-21.16 -12.02,-33.82 5.45,-11.48 18.41,-16.95 30.21,-13.38 -2.94,1.25 -5.46,3.53 -6.94,6.65 -3.23,6.79 -0.35,14.9 6.43,18.12 6.61,3.14 14.52,0.48 17.91,-5.92 13.25,-25.99 1.33,-61.77 -32.4,-77.8 -6.11,-2.91 -12.43,-4.79 -18.79,-5.77 l -35.76,89.57 c 9.12,6.71 16.16,15.7 20.38,26.21 6.02,15 5.73,31.59 -0.81,46.7 l -5.9,13.72 c -8.91,20.61 -9.27,43.46 -1,64.34 8.26,20.87 24.16,37.28 44.77,46.2 20.38,8.81 42.97,9.24 63.65,1.24 32,-14.16 65.48,-23.22 99.95,-27.16 v -105.48 c 13.32,-9.94 22.84,-24.68 26.02,-41.66 -27.27,3.87 -50.86,19.23 -65.66,41.04 v -105.49 c 14.83,21.88 38.48,37.25 65.84,41.09 -5.47,-31.84 -33.19,-56.07 -66.58,-56.07 z m 79.93,427.06 h 0.01 v -0.01 h -0.01 z m 267.75,-334.48 c -3.05,7.6 -2.86,16.09 0.53,23.94 l 5.86,13.65 c 12.07,27.88 12.56,58.79 1.38,87.03 -11.19,28.25 -32.7,50.45 -60.58,62.51 -27.8,12.03 -58.64,12.54 -86.81,1.43 l -1.33,-0.55 -0.26,-0.15 c -27.96,-12.27 -57.17,-20.29 -87.23,-24.03 -1.41,13.06 -9.19,24.18 -20.16,30.26 17.8,7.49 30.3,25.09 30.3,45.6 0,12.29 -4.5,23.51 -11.93,32.14 h 0.1 l -11.24,13.2 c -9.53,11.2 -15.86,25.24 -17.63,40.7 15.45,-1.76 29.5,-8.09 40.71,-17.63 v 52.75 c -11.21,-9.54 -25.26,-15.86 -40.71,-17.62 1.77,15.45 8.1,29.49 17.63,40.69 h -52.75 c 9.54,-11.2 15.87,-25.24 17.62,-40.69 -15.45,1.76 -29.49,8.08 -40.7,17.62 v -52.75 c 11.21,9.54 25.25,15.87 40.7,17.63 -1.75,-15.46 -8.08,-29.5 -17.62,-40.7 l -11.23,-13.2 h 0.08 c -7.42,-8.63 -11.92,-19.85 -11.92,-32.14 0,-20.51 12.5,-38.11 30.29,-45.6 -10.95,-6.08 -18.75,-17.2 -20.16,-30.26 -30.06,3.74 -59.29,11.77 -87.27,24.04 l -1.55,0.69 c -28.18,11.11 -59,10.6 -86.8,-1.43 -27.88,-12.06 -49.4,-34.26 -60.58,-62.51 -11.18,-28.24 -10.69,-59.15 1.35,-86.99 l 5.9,-13.73 c 3.38,-7.81 3.57,-16.3 0.51,-23.9 -3.07,-7.66 -9.19,-13.79 -17.24,-17.27 l -13.23,-5.73 49.99,-125.26 22.96,-58.36 c 70.27,30.01 146.56,45.8 225.28,45.8 78.71,0 154.99,-15.79 225.26,-45.8 l 22.96,58.36 50,125.26 -13.24,5.73 c -8.04,3.48 -14.16,9.61 -17.24,17.27",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath82)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path83",
    d: "m 3404.11,3636.17 c -287.86,0 -521.22,-233.36 -521.22,-521.2 0,-287.86 233.36,-521.21 521.22,-521.21 287.86,0 521.21,233.35 521.21,521.21 0,287.84 -233.35,521.2 -521.21,521.2 z m 0,-54.15 c 257.53,0 467.06,-209.52 467.06,-467.05 0,-257.54 -209.53,-467.06 -467.06,-467.06 -257.54,0 -467.06,209.52 -467.06,467.06 0,257.53 209.52,467.05 467.06,467.05",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath84)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path85",
    d: "M 4460.06,4346.91 H 2348.15 V 1639.33 h 2111.91 z m -54.15,-54.15 V 1693.49 H 2402.3 v 2599.27 h 2003.61",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path87",
    d: "m 2818.42,2268.36 c 42.15,0 66.56,17.48 66.56,71.81 v 165.09 h 69.42 v -159.11 c 0,-91.92 -42.13,-129.02 -137.64,-129.02 -95.52,0 -137.66,37.1 -137.66,129.02 v 159.13 h 72.79 v -165.11 c 0,-54.33 24.41,-71.81 66.53,-71.81",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath88)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path89",
    d: "m 3155.07,2505.26 v -114.09 c 0,-3.36 1.44,-4.79 4.79,-4.79 h 17.96 c 4.3,0 6.45,0.96 8.85,3.83 l 91.5,115.08 h 85.41 l -105.34,-129.44 c -1.91,-2.39 -2.39,-2.87 -2.39,-5.27 v -5.02 c 0,-2.4 0.48,-3.35 2.39,-5.27 l 122.1,-139.1 h -97.94 l -95.73,118.51 c -1.91,2.39 -3.34,3.36 -7.66,3.36 h -19.15 c -3.35,0 -4.79,-1.45 -4.79,-4.79 v -117.03 l -72.77,0.08 v 283.94 h 72.77",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path91",
    d: "m 3657.02,2338.34 c 2.04,0 3.45,2.04 2.71,3.94 l -41.09,106.68 c -1.2,3.12 -2.4,3.84 -5.26,3.84 h -4.31 c -2.89,0 -4.08,-0.72 -5.27,-3.84 l -40.89,-106.65 c -0.72,-1.9 0.68,-3.94 2.72,-3.94 z m 47.66,-117.12 -22.6,60.18 c -1.68,4.31 -3.83,4.84 -8.15,4.78 -10.14,-0.12 -38.1,0.05 -65.62,0.08 -25.58,0.02 -49.99,-0.18 -59.81,-0.08 -4.32,0.05 -6.46,-0.47 -8.14,-4.78 l -22.83,-60.18 h -74.57 l 117.99,283.98 h 102.94 l 117.99,-283.98 h -77.2",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath92)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path93",
    d: "m 4105.88,2495.78 c 5.91,-1.79 7.4,-2.39 7.4,-2.39 l 0.02,-17.48 0.06,-25.19 v -8.67 c 0,0 -9.64,2.02 -11.31,2.26 -17.49,3.59 -55.06,11.98 -97.9,11.98 -33.52,0 -62.25,-4.8 -62.25,-28.49 0,-22.98 19.87,-25.62 69.18,-32.79 71.58,-10.3 118.02,-22.28 118.02,-89.29 0,-73.03 -73.02,-88.59 -141.96,-88.59 -48.59,0 -102.7,9.58 -113.22,13.41 -5.74,1.92 -6.17,2.06 -6.17,2.06 l 0.07,20.69 -0.13,27.04 0.04,7.02 c 0,0 7.87,-1.74 9.54,-2.24 37.59,-9.09 75.88,-15.56 117.06,-15.56 20.83,0 60.57,1.45 60.57,30.18 0,20.82 -9.1,26.8 -67.28,34.95 -69.42,9.82 -119.2,25.14 -119.2,88.08 0,71.59 67.26,85.7 137.39,85.7 45.01,0 90.5,-9.33 100.07,-12.68",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath94)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path95",
    d: "M 2564.76,3554.16 H 2402.3 v 28.65 h 162.46 v -28.65",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath96)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path97",
    d: "M 2564.76,3100.64 H 2402.3 v 28.66 h 162.46 v -28.66",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path99",
    d: "m 2483.53,3463.45 h -81.23 v 28.66 h 81.23 v -28.66",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath100)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path101",
    d: "m 2483.53,3372.75 h -81.23 v 28.66 h 81.23 v -28.66",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath102)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path103",
    d: "m 2483.53,3282.05 h -81.23 v 28.65 h 81.23 v -28.65",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath104)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path105",
    d: "M 2483.53,3191.34 H 2402.3 V 3220 h 81.23 v -28.66",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath106)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path107",
    d: "M 2557.99,2647.12 H 2402.3 v 28.65 h 155.69 v -28.65",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath108)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path109",
    d: "m 2483.53,3009.94 h -81.23 v 28.65 h 81.23 v -28.65",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath110)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path111",
    d: "m 2483.53,2919.23 h -81.23 v 28.66 h 81.23 v -28.66",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path113",
    d: "m 2483.53,2828.52 h -81.23 v 28.66 h 81.23 v -28.66",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path115",
    d: "m 2483.53,2737.82 h -81.23 v 28.65 h 81.23 v -28.65",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath116)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path117",
    d: "m 4405.91,2647.12 h -162.45 v 28.65 h 162.45 v -28.65",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath118)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path119",
    d: "m 4405.91,3100.64 h -162.45 v 28.66 h 162.45 v -28.66",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath120)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path121",
    d: "m 4405.91,2737.82 h -81.23 v 28.65 h 81.23 v -28.65",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path123",
    d: "m 4405.91,2828.52 h -81.23 v 28.66 h 81.23 v -28.66",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath124)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path125",
    d: "m 4405.91,2919.23 h -81.23 v 28.66 h 81.23 v -28.66",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath126)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path127",
    d: "m 4405.91,3009.94 h -81.23 v 28.65 h 81.23 v -28.65",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath128)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path129",
    d: "m 4405.91,3554.16 h -155.69 v 28.65 h 155.69 v -28.65",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath130)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path131",
    d: "m 4405.91,3191.34 h -81.23 V 3220 h 81.23 v -28.66",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath132)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path133",
    d: "m 4405.91,3282.05 h -81.23 v 28.65 h 81.23 v -28.65",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath134)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path135",
    d: "m 4405.91,3372.75 h -81.23 v 28.66 h 81.23 v -28.66",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath136)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path137",
    d: "m 4405.91,3463.45 h -81.23 v 28.66 h 81.23 v -28.66",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath138)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path139",
    d: "M 4478.74,4478.74 H 56.6914 V 56.6914 H 4478.74 Z",
    style: {
      fill: "none",
      stroke: "#13100f",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path140",
    d: "M 2348.81,1318.61 H 88.1094 V 4434.44 H 2348.81 V 1318.61",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath141)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path142",
    d: "M 813.738,1435.85 V 3195.51 H 226.07 V 1435.85 h 587.668",
    style: {
      fill: "url(#linearGradient146)",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath146)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path147",
    d: "m 2218.4,3422.44 v 894.79 L 226.051,1435.85 H 864.039 L 2218.4,3422.44",
    style: {
      fill: "#254177",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath148)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path149",
    d: "M 2218.4,2485 1502.86,1435.85 H 2218.4 V 2485",
    style: {
      fill: "#d41d2b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath150)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path151",
    d: "m 280.488,3875.58 h 60.153 l -22.961,62.76 c -1.039,2.78 -2.2,6.06 -3.461,9.85 -1.25,3.78 -2.5,7.89 -3.719,12.32 -1.211,-4.43 -2.41,-8.56 -3.59,-12.39 -1.172,-3.82 -2.332,-7.18 -3.449,-10.05 z m 122.133,-71.23 h -27.152 c -3.039,0 -5.539,0.76 -7.5,2.28 -1.949,1.52 -3.367,3.41 -4.239,5.67 l -14.089,38.49 H 271.5 l -14.102,-38.49 c -0.687,-1.99 -2.07,-3.82 -4.109,-5.47 -2.039,-1.66 -4.539,-2.48 -7.5,-2.48 H 218.531 L 292.629,3993 h 35.883 l 74.109,-188.65",
    style: {
      fill: "#26417b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath152)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path153",
    d: "m 499.68,3912.11 c -0.871,-1.39 -1.782,-2.37 -2.739,-2.93 -0.961,-0.57 -2.179,-0.85 -3.652,-0.85 -1.559,0 -3.238,0.43 -5.027,1.3 -1.782,0.87 -3.852,1.85 -6.203,2.94 -2.34,1.08 -5.02,2.06 -8.02,2.93 -3,0.87 -6.551,1.31 -10.629,1.31 -6.351,0 -11.351,-1.35 -15,-4.04 -3.66,-2.7 -5.488,-6.23 -5.488,-10.57 0,-2.87 0.93,-5.29 2.808,-7.24 1.872,-1.96 4.34,-3.68 7.43,-5.16 3.09,-1.48 6.59,-2.8 10.512,-3.98 3.906,-1.17 7.918,-2.45 12,-3.85 4.09,-1.39 8.09,-2.97 12.008,-4.76 3.91,-1.78 7.41,-4.04 10.5,-6.78 3.09,-2.74 5.558,-6.03 7.429,-9.86 1.871,-3.82 2.813,-8.43 2.813,-13.83 0,-6.43 -1.184,-12.37 -3.524,-17.8 -2.347,-5.44 -5.789,-10.13 -10.308,-14.09 -4.52,-3.96 -10.11,-7.04 -16.77,-9.26 -6.648,-2.22 -14.281,-3.33 -22.89,-3.33 -4.621,0 -9.121,0.42 -13.508,1.24 -4.391,0.83 -8.613,1.98 -12.652,3.46 -4.051,1.47 -7.782,3.21 -11.219,5.21 -3.442,2.01 -6.461,4.18 -9.071,6.53 l 7.43,12.26 c 0.961,1.48 2.102,2.61 3.391,3.4 1.32,0.78 2.969,1.17 4.969,1.17 2,0 3.902,-0.57 5.671,-1.7 1.789,-1.13 3.848,-2.35 6.2,-3.65 2.347,-1.3 5.109,-2.52 8.289,-3.66 3.172,-1.12 7.191,-1.69 12.058,-1.69 3.832,0 7.114,0.46 9.852,1.37 2.738,0.91 5,2.11 6.789,3.59 1.781,1.47 3.09,3.19 3.91,5.15 0.832,1.96 1.242,3.98 1.242,6.06 0,3.13 -0.941,5.7 -2.801,7.71 -1.871,1.99 -4.351,3.73 -7.441,5.21 -3.09,1.49 -6.609,2.81 -10.57,3.98 -3.949,1.18 -8.008,2.46 -12.129,3.85 -4.129,1.39 -8.18,3.03 -12.141,4.89 -3.949,1.87 -7.48,4.25 -10.558,7.11 -3.09,2.87 -5.571,6.4 -7.43,10.58 -1.883,4.17 -2.813,9.21 -2.813,15.12 0,5.49 1.082,10.71 3.262,15.66 2.168,4.96 5.371,9.28 9.59,12.98 4.211,3.7 9.48,6.66 15.789,8.88 6.301,2.22 13.582,3.32 21.852,3.32 9.211,0 17.609,-1.52 25.179,-4.56 7.559,-3.05 13.871,-7.05 18.918,-12.01 l -7.308,-11.61",
    style: {
      fill: "#26417b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath154)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path155",
    d: "m 613.711,3912.11 c -0.883,-1.39 -1.789,-2.37 -2.742,-2.93 -0.957,-0.57 -2.18,-0.85 -3.66,-0.85 -1.559,0 -3.239,0.43 -5.02,1.3 -1.789,0.87 -3.859,1.85 -6.187,2.94 -2.364,1.08 -5.032,2.06 -8.032,2.93 -3,0.87 -6.55,1.31 -10.629,1.31 -6.363,0 -11.363,-1.35 -15.011,-4.04 -3.66,-2.7 -5.481,-6.23 -5.481,-10.57 0,-2.87 0.93,-5.29 2.813,-7.24 1.867,-1.96 4.347,-3.68 7.429,-5.16 3.09,-1.48 6.59,-2.8 10.508,-3.98 3.91,-1.17 7.91,-2.45 12.012,-3.85 4.078,-1.39 8.078,-2.97 12,-4.76 3.91,-1.78 7.398,-4.04 10.488,-6.78 3.09,-2.74 5.571,-6.03 7.442,-9.86 1.871,-3.82 2.8,-8.43 2.8,-13.83 0,-6.43 -1.171,-12.37 -3.519,-17.8 -2.344,-5.44 -5.781,-10.13 -10.301,-14.09 -4.531,-3.96 -10.109,-7.04 -16.762,-9.26 -6.668,-2.22 -14.3,-3.33 -22.91,-3.33 -4.597,0 -9.109,0.42 -13.5,1.24 -4.398,0.83 -8.609,1.98 -12.648,3.46 -4.039,1.47 -7.789,3.21 -11.223,5.21 -3.437,2.01 -6.457,4.18 -9.066,6.53 l 7.429,12.26 c 0.957,1.48 2.09,2.61 3.399,3.4 1.301,0.78 2.961,1.17 4.949,1.17 2,0 3.902,-0.57 5.691,-1.7 1.77,-1.13 3.84,-2.35 6.192,-3.65 2.348,-1.3 5.109,-2.52 8.277,-3.66 3.18,-1.12 7.192,-1.69 12.071,-1.69 3.832,0 7.121,0.46 9.851,1.37 2.738,0.91 5.008,2.11 6.777,3.59 1.793,1.47 3.09,3.19 3.922,5.15 0.821,1.96 1.239,3.98 1.239,6.06 0,3.13 -0.938,5.7 -2.809,7.71 -1.871,1.99 -4.34,3.73 -7.43,5.21 -3.09,1.49 -6.609,2.81 -10.57,3.98 -3.949,1.18 -8.012,2.46 -12.141,3.85 -4.129,1.39 -8.168,3.03 -12.129,4.89 -3.949,1.87 -7.48,4.25 -10.57,7.11 -3.082,2.87 -5.57,6.4 -7.43,10.58 -1.871,4.17 -2.8,9.21 -2.8,15.12 0,5.49 1.082,10.71 3.25,15.66 2.179,4.96 5.379,9.28 9.59,12.98 4.218,3.7 9.48,6.66 15.789,8.88 6.312,2.22 13.589,3.32 21.851,3.32 9.219,0 17.621,-1.52 25.192,-4.56 7.558,-3.05 13.859,-7.05 18.91,-12.01 l -7.301,-11.61",
    style: {
      fill: "#26417b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath156)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path157",
    d: "m 704.25,3917.2 c -9.398,0 -16.738,-2.65 -22.051,-7.96 -5.308,-5.3 -8.699,-12.82 -10.168,-22.57 h 60.528 c 0,4.18 -0.571,8.11 -1.7,11.81 -1.129,3.69 -2.871,6.93 -5.218,9.72 -2.34,2.78 -5.301,4.98 -8.871,6.59 -3.559,1.6 -7.739,2.41 -12.52,2.41 z m -0.648,23.09 c 8.429,0 16.199,-1.35 23.289,-4.04 7.078,-2.7 13.187,-6.64 18.32,-11.81 5.141,-5.17 9.141,-11.53 12.008,-19.05 2.871,-7.52 4.301,-16.11 4.301,-25.77 0,-2.43 -0.098,-4.45 -0.321,-6.06 -0.219,-1.61 -0.621,-2.87 -1.179,-3.79 -0.559,-0.91 -1.321,-1.56 -2.27,-1.95 -0.961,-0.39 -2.18,-0.59 -3.672,-0.59 h -82.707 c 0.957,-13.74 4.66,-23.83 11.098,-30.27 6.429,-6.43 14.953,-9.65 25.562,-9.65 5.219,0 9.719,0.61 13.508,1.82 3.781,1.23 7.082,2.57 9.91,4.05 2.821,1.48 5.313,2.82 7.442,4.04 2.129,1.22 4.187,1.83 6.199,1.83 1.301,0 2.43,-0.26 3.39,-0.78 0.961,-0.52 1.782,-1.26 2.481,-2.22 l 9.391,-11.75 c -3.563,-4.17 -7.563,-7.67 -12,-10.49 -4.43,-2.83 -9.071,-5.09 -13.903,-6.78 -4.828,-1.71 -9.738,-2.89 -14.738,-3.6 -5,-0.69 -9.852,-1.04 -14.551,-1.04 -9.308,0 -17.961,1.55 -25.961,4.64 -8.008,3.08 -14.961,7.65 -20.879,13.69 -5.922,6.05 -10.558,13.52 -13.949,22.44 -3.391,8.91 -5.101,19.24 -5.101,30.99 0,9.13 1.48,17.72 4.441,25.76 2.961,8.05 7.199,15.05 12.719,21.01 5.531,5.96 12.261,10.67 20.23,14.15 7.961,3.48 16.93,5.22 26.942,5.22",
    style: {
      fill: "#26417b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path159",
    d: "m 867.199,3912.11 c -0.871,-1.39 -1.789,-2.37 -2.73,-2.93 -0.969,-0.57 -2.18,-0.85 -3.668,-0.85 -1.551,0 -3.231,0.43 -5.02,1.3 -1.769,0.87 -3.851,1.85 -6.203,2.94 -2.34,1.08 -5.019,2.06 -8.019,2.93 -3,0.87 -6.539,1.31 -10.629,1.31 -6.352,0 -11.36,-1.35 -15.008,-4.04 -3.641,-2.7 -5.481,-6.23 -5.481,-10.57 0,-2.87 0.938,-5.29 2.809,-7.24 1.871,-1.96 4.352,-3.68 7.441,-5.16 3.09,-1.48 6.59,-2.8 10.5,-3.98 3.918,-1.17 7.918,-2.45 12.008,-3.85 4.082,-1.39 8.082,-2.97 12,-4.76 3.922,-1.78 7.422,-4.04 10.5,-6.78 3.09,-2.74 5.571,-6.03 7.442,-9.86 1.859,-3.82 2.8,-8.43 2.8,-13.83 0,-6.43 -1.171,-12.37 -3.519,-17.8 -2.352,-5.44 -5.781,-10.13 -10.313,-14.09 -4.519,-3.96 -10.109,-7.04 -16.757,-9.26 -6.661,-2.22 -14.293,-3.33 -22.903,-3.33 -4.621,0 -9.109,0.42 -13.508,1.24 -4.39,0.83 -8.613,1.98 -12.652,3.46 -4.039,1.47 -7.789,3.21 -11.219,5.21 -3.441,2.01 -6.449,4.18 -9.07,6.53 l 7.441,12.26 c 0.957,1.48 2.079,2.61 3.399,3.4 1.289,0.78 2.941,1.17 4.949,1.17 2,0 3.891,-0.57 5.672,-1.7 1.777,-1.13 3.848,-2.35 6.199,-3.65 2.352,-1.3 5.11,-2.52 8.281,-3.66 3.18,-1.12 7.207,-1.69 12.079,-1.69 3.832,0 7.109,0.46 9.851,1.37 2.731,0.91 5,2.11 6.777,3.59 1.782,1.47 3.09,3.19 3.911,5.15 0.832,1.96 1.242,3.98 1.242,6.06 0,3.13 -0.93,5.7 -2.813,7.71 -1.859,1.99 -4.34,3.73 -7.429,5.21 -3.09,1.49 -6.61,2.81 -10.571,3.98 -3.957,1.18 -8,2.46 -12.129,3.85 -4.129,1.39 -8.179,3.03 -12.129,4.89 -3.96,1.87 -7.492,4.25 -10.57,7.11 -3.09,2.87 -5.57,6.4 -7.449,10.58 -1.859,4.17 -2.801,9.21 -2.801,15.12 0,5.49 1.09,10.71 3.27,15.66 2.172,4.96 5.371,9.28 9.59,12.98 4.218,3.7 9.48,6.66 15.781,8.88 6.308,2.22 13.597,3.32 21.847,3.32 9.231,0 17.622,-1.52 25.192,-4.56 7.57,-3.05 13.871,-7.05 18.922,-12.01 l -7.313,-11.61",
    style: {
      fill: "#26417b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path161",
    d: "m 981.219,3912.11 c -0.867,-1.39 -1.778,-2.37 -2.731,-2.93 -0.968,-0.57 -2.179,-0.85 -3.66,-0.85 -1.566,0 -3.226,0.43 -5.019,1.3 -1.778,0.87 -3.848,1.85 -6.2,2.94 -2.347,1.08 -5.019,2.06 -8.019,2.93 -3,0.87 -6.551,1.31 -10.641,1.31 -6.34,0 -11.347,-1.35 -15,-4.04 -3.648,-2.7 -5.48,-6.23 -5.48,-10.57 0,-2.87 0.929,-5.29 2.812,-7.24 1.867,-1.96 4.348,-3.68 7.43,-5.16 3.09,-1.48 6.59,-2.8 10.508,-3.98 3.91,-1.17 7.91,-2.45 12,-3.85 4.09,-1.39 8.09,-2.97 12.011,-4.76 3.911,-1.78 7.399,-4.04 10.489,-6.78 3.09,-2.74 5.57,-6.03 7.441,-9.86 1.871,-3.82 2.809,-8.43 2.809,-13.83 0,-6.43 -1.18,-12.37 -3.528,-17.8 -2.351,-5.44 -5.781,-10.13 -10.3,-14.09 -4.52,-3.96 -10.11,-7.04 -16.762,-9.26 -6.66,-2.22 -14.289,-3.33 -22.899,-3.33 -4.621,0 -9.109,0.42 -13.511,1.24 -4.391,0.83 -8.61,1.98 -12.66,3.46 -4.039,1.47 -7.77,3.21 -11.207,5.21 -3.442,2.01 -6.461,4.18 -9.071,6.53 l 7.43,12.26 c 0.961,1.48 2.09,2.61 3.398,3.4 1.301,0.78 2.95,1.17 4.961,1.17 1.989,0 3.891,-0.57 5.668,-1.7 1.782,-1.13 3.852,-2.35 6.203,-3.65 2.348,-1.3 5.11,-2.52 8.278,-3.66 3.179,-1.12 7.203,-1.69 12.07,-1.69 3.832,0 7.109,0.46 9.859,1.37 2.731,0.91 4.993,2.11 6.782,3.59 1.769,1.47 3.082,3.19 3.91,5.15 0.82,1.96 1.238,3.98 1.238,6.06 0,3.13 -0.937,5.7 -2.808,7.71 -1.872,1.99 -4.348,3.73 -7.442,5.21 -3.078,1.49 -6.598,2.81 -10.558,3.98 -3.961,1.18 -8.008,2.46 -12.129,3.85 -4.129,1.39 -8.18,3.03 -12.129,4.89 -3.961,1.87 -7.492,4.25 -10.582,7.11 -3.078,2.87 -5.571,6.4 -7.442,10.58 -1.859,4.17 -2.789,9.21 -2.789,15.12 0,5.49 1.082,10.71 3.262,15.66 2.168,4.96 5.359,9.28 9.59,12.98 4.211,3.7 9.469,6.66 15.777,8.88 6.313,2.22 13.594,3.32 21.852,3.32 9.218,0 17.621,-1.52 25.179,-4.56 7.571,-3.05 13.879,-7.05 18.93,-12.01 l -7.32,-11.61",
    style: {
      fill: "#26417b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath162)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path163",
    d: "m 1015.8,3804.35 v 133.86 h 19.7 c 4.17,0 6.9,-1.96 8.21,-5.87 l 2.09,-9.92 c 2.35,2.61 4.81,5 7.37,7.18 2.57,2.16 5.31,4.04 8.22,5.61 2.92,1.56 6.05,2.8 9.4,3.71 3.34,0.92 7.02,1.37 11.02,1.37 8.44,0 15.38,-2.28 20.81,-6.85 5.44,-4.57 9.5,-10.63 12.2,-18.2 2.09,4.44 4.69,8.24 7.83,11.42 3.13,3.17 6.56,5.76 10.3,7.76 3.75,2 7.73,3.48 11.94,4.44 4.22,0.95 8.46,1.43 12.73,1.43 7.38,0 13.96,-1.13 19.69,-3.39 5.75,-2.26 10.58,-5.57 14.48,-9.91 3.92,-4.35 6.9,-9.66 8.95,-15.93 2.04,-6.25 3.06,-13.43 3.06,-21.52 v -85.19 h -32.22 v 85.19 c 0,8.53 -1.87,14.94 -5.62,19.25 -3.74,4.3 -9.22,6.45 -16.44,6.45 -3.31,0 -6.37,-0.56 -9.2,-1.69 -2.82,-1.14 -5.3,-2.77 -7.43,-4.9 -2.13,-2.13 -3.81,-4.8 -5.03,-8.02 -1.21,-3.22 -1.82,-6.91 -1.82,-11.09 v -85.19 h -32.36 v 85.19 c 0,8.95 -1.8,15.48 -5.41,19.57 -3.6,4.08 -8.93,6.13 -15.98,6.13 -4.61,0 -8.94,-1.15 -12.98,-3.45 -4.05,-2.31 -7.8,-5.47 -11.29,-9.46 v -97.98 h -32.22",
    style: {
      fill: "#26417b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath164)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path165",
    d: "m 1291.48,3917.2 c -9.4,0 -16.75,-2.65 -22.05,-7.96 -5.31,-5.3 -8.7,-12.82 -10.18,-22.57 h 60.54 c 0,4.18 -0.57,8.11 -1.7,11.81 -1.13,3.69 -2.87,6.93 -5.21,9.72 -2.36,2.78 -5.31,4.98 -8.88,6.59 -3.57,1.6 -7.74,2.41 -12.52,2.41 z m -0.65,23.09 c 8.43,0 16.19,-1.35 23.28,-4.04 7.09,-2.7 13.2,-6.64 18.33,-11.81 5.13,-5.17 9.13,-11.53 12.01,-19.05 2.87,-7.52 4.3,-16.11 4.3,-25.77 0,-2.43 -0.11,-4.45 -0.33,-6.06 -0.21,-1.61 -0.6,-2.87 -1.17,-3.79 -0.57,-0.91 -1.33,-1.56 -2.28,-1.95 -0.96,-0.39 -2.18,-0.59 -3.65,-0.59 h -82.73 c 0.96,-13.74 4.66,-23.83 11.09,-30.27 6.44,-6.43 14.97,-9.65 25.58,-9.65 5.22,0 9.71,0.61 13.5,1.82 3.78,1.23 7.09,2.57 9.92,4.05 2.82,1.48 5.31,2.82 7.44,4.04 2.13,1.22 4.19,1.83 6.19,1.83 1.31,0 2.44,-0.26 3.39,-0.78 0.96,-0.52 1.78,-1.26 2.48,-2.22 l 9.4,-11.75 c -3.57,-4.17 -7.58,-7.67 -12.01,-10.49 -4.43,-2.83 -9.06,-5.09 -13.89,-6.78 -4.83,-1.71 -9.75,-2.89 -14.75,-3.6 -4.99,-0.69 -9.84,-1.04 -14.55,-1.04 -9.3,0 -17.96,1.55 -25.95,4.64 -8.01,3.08 -14.96,7.65 -20.88,13.69 -5.91,6.05 -10.57,13.52 -13.96,22.44 -3.39,8.91 -5.09,19.24 -5.09,30.99 0,9.13 1.48,17.72 4.43,25.76 2.96,8.05 7.21,15.05 12.73,21.01 5.52,5.96 12.26,10.67 20.22,14.15 7.96,3.48 16.94,5.22 26.95,5.22",
    style: {
      fill: "#26417b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath166)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path167",
    d: "m 1374.97,3804.35 v 133.86 h 19.7 c 4.17,0 6.91,-1.96 8.22,-5.87 l 2.21,-10.57 c 2.7,2.78 5.55,5.3 8.55,7.56 3,2.26 6.18,4.22 9.53,5.88 3.34,1.65 6.92,2.91 10.76,3.78 3.82,0.87 8,1.3 12.52,1.3 7.31,0 13.79,-1.24 19.44,-3.71 5.65,-2.49 10.37,-5.97 14.15,-10.44 3.79,-4.48 6.66,-9.83 8.61,-16.05 1.97,-6.22 2.95,-13.07 2.95,-20.55 v -85.19 h -32.23 v 85.19 c 0,8.17 -1.89,14.51 -5.68,18.99 -3.77,4.47 -9.46,6.71 -17.02,6.71 -5.57,0 -10.79,-1.26 -15.66,-3.78 -4.87,-2.53 -9.48,-5.96 -13.83,-10.3 v -96.81 h -32.22",
    style: {
      fill: "#26417b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath168)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path169",
    d: "m 1561.42,3802.26 c -11.56,0 -20.48,3.28 -26.74,9.85 -6.27,6.56 -9.4,15.64 -9.4,27.2 v 74.76 h -13.56 c -1.74,0 -3.24,0.56 -4.5,1.7 -1.27,1.12 -1.9,2.82 -1.9,5.08 v 12.79 l 21.53,3.52 6.78,36.53 c 0.36,1.74 1.15,3.09 2.41,4.04 1.27,0.96 2.86,1.44 4.77,1.44 h 16.7 v -42.14 h 35.23 v -22.96 h -35.23 v -72.54 c 0,-4.18 1.05,-7.44 3.13,-9.79 2.09,-2.34 4.87,-3.51 8.36,-3.51 1.99,0 3.67,0.23 5.02,0.71 1.34,0.48 2.52,0.98 3.51,1.5 1.01,0.52 1.9,1.02 2.68,1.5 0.79,0.47 1.57,0.72 2.36,0.72 0.95,0 1.73,-0.25 2.34,-0.72 0.61,-0.48 1.26,-1.2 1.96,-2.15 l 9.65,-15.66 c -4.69,-3.91 -10.09,-6.87 -16.17,-8.87 -6.1,-2 -12.4,-3 -18.93,-3",
    style: {
      fill: "#26417b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath170)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path171",
    d: "m 271.879,3573.93 v -55.31 H 307.5 c 6.531,0 11.98,0.78 16.379,2.35 4.391,1.56 7.91,3.65 10.57,6.26 2.641,2.61 4.563,5.66 5.731,9.13 1.179,3.48 1.761,7.18 1.761,11.1 0,4.08 -0.652,7.75 -1.953,11.02 -1.297,3.26 -3.347,6.05 -6.129,8.35 -2.789,2.31 -6.359,4.07 -10.711,5.28 -4.339,1.22 -9.597,1.82 -15.777,1.82 z m 0,24.27 h 28.051 c 11.922,0 20.968,2.18 27.148,6.53 6.172,4.35 9.25,11.26 9.25,20.74 0,9.84 -2.769,16.83 -8.34,21.01 -5.566,4.17 -14.269,6.26 -26.097,6.26 h -30.012 z m -35.09,-106.98 v 188.66 h 65.102 c 12.347,0 22.898,-1.18 31.64,-3.53 8.739,-2.34 15.918,-5.69 21.528,-10.05 5.613,-4.34 9.722,-9.61 12.32,-15.78 2.609,-6.18 3.922,-13.14 3.922,-20.87 0,-4.44 -0.653,-8.68 -1.949,-12.72 -1.321,-4.04 -3.332,-7.83 -6.071,-11.36 -2.742,-3.52 -6.222,-6.71 -10.441,-9.58 -4.219,-2.87 -9.238,-5.31 -15.07,-7.31 25.91,-5.83 38.871,-19.83 38.871,-42.01 0,-8 -1.512,-15.4 -4.563,-22.18 -3.039,-6.79 -7.476,-12.63 -13.308,-17.54 -5.829,-4.92 -13,-8.77 -21.52,-11.56 -8.531,-2.77 -18.27,-4.17 -29.219,-4.17 h -71.242",
    style: {
      fill: "#26417b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath172)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path173",
    d: "m 433.66,3625.08 v -85.06 c 0,-8.18 1.891,-14.51 5.668,-18.99 3.793,-4.48 9.461,-6.71 17.031,-6.71 5.571,0 10.789,1.24 15.653,3.71 4.879,2.48 9.476,5.89 13.828,10.24 v 96.81 h 32.23 v -133.86 h -19.691 c -4.18,0 -6.93,1.96 -8.219,5.87 l -2.219,10.7 c -2.793,-2.78 -5.66,-5.33 -8.621,-7.63 -2.949,-2.31 -6.101,-4.26 -9.449,-5.87 -3.359,-1.62 -6.973,-2.88 -10.84,-3.78 -3.859,-0.92 -8.019,-1.38 -12.453,-1.38 -7.308,0 -13.769,1.24 -19.379,3.72 -5.609,2.48 -10.328,5.98 -14.148,10.51 -3.84,4.52 -6.723,9.89 -8.68,16.1 -1.961,6.23 -2.93,13.07 -2.93,20.56 v 85.06 h 32.219",
    style: {
      fill: "#26417b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath174)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path175",
    d: "m 551.73,3491.22 v 133.86 h 18.918 c 3.301,0 5.614,-0.61 6.911,-1.83 1.312,-1.21 2.179,-3.3 2.621,-6.26 l 1.949,-16.18 c 4.793,8.27 10.391,14.79 16.832,19.57 6.43,4.79 13.66,7.18 21.66,7.18 6.598,0 12.09,-1.52 16.43,-4.57 l -4.172,-24.13 c -0.258,-1.57 -0.82,-2.68 -1.688,-3.33 -0.882,-0.65 -2.05,-0.98 -3.531,-0.98 -1.301,0 -3.09,0.31 -5.351,0.92 -2.258,0.6 -5.258,0.91 -8.989,0.91 -6.699,0 -12.449,-1.85 -17.218,-5.55 -4.801,-3.69 -8.832,-9.1 -12.141,-16.24 v -83.37 H 551.73",
    style: {
      fill: "#26417b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath176)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path177",
    d: "m 713.512,3604.08 c -9.391,0 -16.742,-2.66 -22.051,-7.96 -5.313,-5.31 -8.691,-12.84 -10.18,-22.57 h 60.539 c 0,4.17 -0.57,8.11 -1.691,11.8 -1.141,3.7 -2.879,6.94 -5.219,9.73 -2.351,2.78 -5.308,4.97 -8.879,6.59 -3.57,1.6 -7.742,2.41 -12.519,2.41 z m -0.653,23.09 c 8.43,0 16.2,-1.35 23.289,-4.04 7.082,-2.7 13.192,-6.64 18.321,-11.81 5.133,-5.18 9.133,-11.53 12,-19.05 2.883,-7.53 4.312,-16.12 4.312,-25.77 0,-2.43 -0.109,-4.46 -0.32,-6.06 -0.223,-1.61 -0.621,-2.87 -1.18,-3.79 -0.562,-0.91 -1.32,-1.57 -2.281,-1.96 -0.949,-0.39 -2.18,-0.59 -3.66,-0.59 h -82.711 c 0.961,-13.74 4.652,-23.82 11.09,-30.26 6.441,-6.44 14.961,-9.66 25.57,-9.66 5.223,0 9.723,0.61 13.5,1.83 3.789,1.22 7.09,2.56 9.922,4.04 2.82,1.49 5.309,2.83 7.437,4.05 2.133,1.22 4.192,1.83 6.204,1.83 1.296,0 2.429,-0.27 3.386,-0.79 0.953,-0.52 1.782,-1.26 2.481,-2.22 l 9.39,-11.73 c -3.558,-4.18 -7.57,-7.68 -12,-10.51 -4.437,-2.83 -9.058,-5.09 -13.898,-6.78 -4.832,-1.7 -9.75,-2.9 -14.742,-3.59 -5,-0.69 -9.848,-1.04 -14.547,-1.04 -9.313,0 -17.961,1.54 -25.961,4.63 -8.012,3.08 -14.961,7.65 -20.883,13.7 -5.906,6.04 -10.566,13.52 -13.949,22.44 -3.391,8.92 -5.098,19.24 -5.098,30.98 0,9.13 1.481,17.72 4.438,25.77 2.961,8.04 7.203,15.05 12.722,21 5.528,5.96 12.258,10.68 20.219,14.16 7.961,3.48 16.949,5.22 26.949,5.22",
    style: {
      fill: "#26417b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath178)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path179",
    d: "m 838.488,3511.31 c 3.301,0 6.352,0.3 9.133,0.9 2.789,0.6 5.418,1.5 7.91,2.71 2.469,1.19 4.86,2.66 7.16,4.42 2.309,1.75 4.629,3.83 6.989,6.23 v 22.4 c -9.399,0 -17.25,-0.59 -23.559,-1.77 -6.301,-1.18 -11.371,-2.7 -15.191,-4.53 -3.828,-1.84 -6.551,-3.99 -8.16,-6.44 -1.61,-2.45 -2.411,-5.12 -2.411,-8.02 0,-5.69 1.672,-9.77 5.02,-12.21 3.351,-2.46 7.723,-3.69 13.109,-3.69 z m 62.621,-20.09 h -14.48 c -3.039,0 -5.43,0.46 -7.168,1.37 -1.742,0.92 -3.039,2.76 -3.922,5.55 l -2.859,9.52 c -3.399,-3.04 -6.719,-5.72 -9.989,-8.02 -3.261,-2.31 -6.632,-4.25 -10.101,-5.81 -3.481,-1.57 -7.18,-2.73 -11.102,-3.52 -3.91,-0.78 -8.258,-1.18 -13.039,-1.18 -5.66,0 -10.871,0.77 -15.668,2.3 -4.769,1.52 -8.89,3.81 -12.32,6.87 -3.441,3.05 -6.121,6.85 -8.02,11.39 -1.921,4.53 -2.871,9.81 -2.871,15.84 0,5.06 1.328,10.06 3.969,14.99 2.652,4.92 7.07,9.38 13.242,13.34 6.18,3.97 14.399,7.27 24.668,9.89 10.262,2.61 23.012,3.93 38.231,3.93 v 7.88 c 0,9.03 -1.891,15.71 -5.68,20.05 -3.789,4.34 -9.289,6.51 -16.5,6.51 -5.219,0 -9.57,-0.61 -13.059,-1.83 -3.472,-1.22 -6.5,-2.58 -9.062,-4.11 -2.559,-1.52 -4.938,-2.89 -7.109,-4.11 -2.18,-1.22 -4.571,-1.82 -7.168,-1.82 -2.18,0 -4.051,0.56 -5.622,1.69 -1.558,1.13 -2.82,2.53 -3.781,4.18 l -5.871,10.3 c 15.391,14.1 33.961,21.14 55.723,21.14 7.82,0 14.801,-1.29 20.929,-3.85 6.141,-2.57 11.329,-6.13 15.59,-10.7 4.258,-4.56 7.5,-10.02 9.719,-16.37 2.223,-6.35 3.32,-13.31 3.32,-20.88 v -84.54",
    style: {
      fill: "#26417b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path181",
    d: "m 961.531,3625.08 v -85.06 c 0,-8.18 1.879,-14.51 5.668,-18.99 3.781,-4.48 9.461,-6.71 17.031,-6.71 5.571,0 10.79,1.24 15.661,3.71 4.859,2.48 9.469,5.89 13.829,10.24 v 96.81 h 32.22 v -133.86 h -19.7 c -4.18,0 -6.92,1.96 -8.22,5.87 l -2.22,10.7 c -2.78,-2.78 -5.66,-5.33 -8.61,-7.63 -2.95,-2.31 -6.11,-4.26 -9.452,-5.87 -3.359,-1.62 -6.968,-2.88 -10.828,-3.78 -3.879,-0.92 -8.031,-1.38 -12.461,-1.38 -7.308,0 -13.769,1.24 -19.379,3.72 -5.609,2.48 -10.332,5.98 -14.16,10.51 -3.832,4.52 -6.719,9.89 -8.672,16.1 -1.957,6.23 -2.937,13.07 -2.937,20.56 v 85.06 h 32.23",
    style: {
      fill: "#26417b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath182)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path183",
    d: "m 269.02,4200.54 v -54.29 h 34.949 c 6.402,0 11.769,0.76 16.07,2.31 4.32,1.53 7.77,3.58 10.383,6.14 2.59,2.56 4.469,5.55 5.617,8.96 1.16,3.41 1.731,7.05 1.731,10.89 0,4.01 -0.629,7.61 -1.911,10.81 -1.289,3.2 -3.289,5.94 -6.019,8.2 -2.738,2.26 -6.238,3.99 -10.5,5.19 -4.27,1.19 -9.43,1.79 -15.5,1.79 z m 0,23.81 h 27.519 c 11.691,0 20.582,2.14 26.641,6.41 6.058,4.27 9.09,11.05 9.09,20.36 0,9.64 -2.731,16.51 -8.2,20.61 -5.461,4.1 -13.992,6.15 -25.601,6.15 H 269.02 Z m -34.45,-104.99 v 185.15 h 63.899 c 12.109,0 22.472,-1.15 31.051,-3.45 8.582,-2.31 15.621,-5.6 21.121,-9.87 5.507,-4.27 9.539,-9.43 12.109,-15.49 2.551,-6.06 3.828,-12.89 3.828,-20.49 0,-4.35 -0.629,-8.51 -1.918,-12.48 -1.281,-3.97 -3.262,-7.68 -5.949,-11.14 -2.691,-3.46 -6.102,-6.6 -10.242,-9.41 -4.141,-2.82 -9.071,-5.21 -14.797,-7.18 25.437,-5.72 38.168,-19.46 38.168,-41.22 0,-7.86 -1.5,-15.11 -4.481,-21.77 -3,-6.65 -7.347,-12.4 -13.07,-17.22 -5.711,-4.83 -12.75,-8.6 -21.129,-11.34 -8.359,-2.73 -17.922,-4.09 -28.68,-4.09 h -69.91",
    style: {
      fill: "#254177",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath184)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path185",
    d: "m 399.609,4119.36 v 131.38 h 18.571 c 3.242,0 5.511,-0.61 6.789,-1.8 1.281,-1.2 2.133,-3.25 2.562,-6.15 l 1.918,-15.87 c 4.692,8.11 10.192,14.51 16.52,19.2 6.312,4.7 13.402,7.04 21.25,7.04 6.492,0 11.871,-1.49 16.14,-4.47 l -4.097,-23.7 c -0.262,-1.53 -0.813,-2.62 -1.66,-3.26 -0.864,-0.64 -2.012,-0.96 -3.461,-0.96 -1.289,0 -3.032,0.3 -5.25,0.9 -2.219,0.59 -5.172,0.89 -8.832,0.89 -6.579,0 -12.219,-1.81 -16.911,-5.44 -4.687,-3.63 -8.668,-8.94 -11.898,-15.94 v -81.82 h -31.641",
    style: {
      fill: "#254177",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath186)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path187",
    d: "M 537.898,4250.74 V 4119.36 H 506.27 v 131.38 z m 4.743,38.28 c 0,-2.74 -0.563,-5.29 -1.661,-7.68 -1.109,-2.4 -2.582,-4.49 -4.421,-6.28 -1.829,-1.8 -3.989,-3.23 -6.457,-4.29 -2.481,-1.07 -5.133,-1.6 -7.942,-1.6 -2.75,0 -5.32,0.53 -7.75,1.6 -2.43,1.06 -4.551,2.49 -6.351,4.29 -1.789,1.79 -3.207,3.88 -4.278,6.28 -1.07,2.39 -1.601,4.94 -1.601,7.68 0,2.81 0.531,5.46 1.601,7.94 1.071,2.47 2.489,4.61 4.278,6.4 1.8,1.79 3.921,3.22 6.351,4.29 2.43,1.07 5,1.6 7.75,1.6 2.809,0 5.461,-0.53 7.942,-1.6 2.468,-1.07 4.628,-2.5 6.457,-4.29 1.839,-1.79 3.312,-3.93 4.421,-6.4 1.098,-2.48 1.661,-5.13 1.661,-7.94",
    style: {
      fill: "#254177",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath188)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path189",
    d: "m 612.93,4290.94 h -16.391 c -1.879,0 -3.43,-0.47 -4.668,-1.41 -1.242,-0.94 -2.031,-2.26 -2.371,-3.97 l -6.66,-35.86 -21.129,-3.45 v -12.55 c 0,-2.22 0.617,-3.89 1.859,-4.99 1.239,-1.11 2.711,-1.67 4.418,-1.67 h 13.313 v -73.36 c 0,-11.36 3.078,-20.26 9.219,-26.7 6.152,-6.45 14.89,-9.67 26.25,-9.67 6.41,0 12.601,0.98 18.57,2.94 5.98,1.97 11.262,4.87 15.879,8.71 l -9.481,15.36 c -0.679,0.95 -1.316,1.66 -1.918,2.12 -0.601,0.47 -1.359,0.71 -2.3,0.71 -0.782,0 -1.54,-0.24 -2.321,-0.71 -0.758,-0.46 -1.629,-0.96 -2.609,-1.47 -0.981,-0.51 -2.141,-1.01 -3.469,-1.47 -1.32,-0.47 -2.961,-0.71 -4.922,-0.71 -3.418,0 -6.148,1.15 -8.199,3.46 -2.039,2.31 -3.07,5.5 -3.07,9.6 v 71.19 h 61.851 v -107.68 h 31.629 v 130.22 h -93.48 v 41.36",
    style: {
      fill: "#254177",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath190)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path191",
    d: "m 709.48,4296.96 c -1.121,2.47 -2.589,4.61 -4.429,6.4 -1.832,1.79 -3.992,3.22 -6.461,4.29 -2.481,1.07 -5.121,1.6 -7.93,1.6 -2.738,0 -5.332,-0.53 -7.75,-1.6 -2.441,-1.07 -4.551,-2.5 -6.34,-4.29 -1.789,-1.79 -3.218,-3.93 -4.289,-6.4 -1.07,-2.48 -1.601,-5.13 -1.601,-7.94 0,-2.74 0.531,-5.29 1.601,-7.68 1.071,-2.4 2.5,-4.49 4.289,-6.28 1.789,-1.8 3.899,-3.23 6.34,-4.29 2.418,-1.07 5.012,-1.6 7.75,-1.6 2.809,0 5.449,0.53 7.93,1.6 2.469,1.06 4.629,2.49 6.461,4.29 1.84,1.79 3.308,3.88 4.429,6.28 1.098,2.39 1.649,4.94 1.649,7.68 0,2.81 -0.551,5.46 -1.649,7.94",
    style: {
      fill: "#254177",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath192)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path193",
    d: "m 820.109,4225.12 c -0.859,-1.36 -1.75,-2.32 -2.687,-2.88 -0.953,-0.55 -2.141,-0.83 -3.594,-0.83 -1.527,0 -3.18,0.43 -4.93,1.28 -1.738,0.85 -3.769,1.81 -6.07,2.88 -2.308,1.07 -4.937,2.03 -7.887,2.88 -2.941,0.86 -6.421,1.28 -10.429,1.28 -6.231,0 -11.141,-1.32 -14.731,-3.97 -3.582,-2.65 -5.371,-6.1 -5.371,-10.36 0,-2.83 0.91,-5.19 2.75,-7.12 1.84,-1.91 4.27,-3.6 7.301,-5.06 3.027,-1.45 6.461,-2.74 10.309,-3.9 3.839,-1.15 7.761,-2.41 11.769,-3.78 4.02,-1.36 7.941,-2.92 11.789,-4.67 3.844,-1.75 7.274,-3.97 10.301,-6.66 3.031,-2.69 5.473,-5.91 7.312,-9.66 1.829,-3.76 2.75,-8.29 2.75,-13.58 0,-6.32 -1.152,-12.14 -3.461,-17.47 -2.308,-5.34 -5.679,-9.95 -10.121,-13.83 -4.429,-3.89 -9.918,-6.92 -16.449,-9.09 -6.519,-2.18 -14.019,-3.27 -22.469,-3.27 -4.531,0 -8.941,0.41 -13.25,1.21 -4.312,0.82 -8.453,1.95 -12.429,3.4 -3.961,1.45 -7.633,3.16 -11,5.12 -3.383,1.97 -6.34,4.1 -8.91,6.4 l 7.296,12.04 c 0.942,1.45 2.051,2.56 3.332,3.33 1.282,0.77 2.899,1.15 4.872,1.15 1.957,0 3.82,-0.56 5.558,-1.66 1.762,-1.12 3.789,-2.3 6.09,-3.59 2.301,-1.28 5.02,-2.47 8.129,-3.59 3.121,-1.1 7.062,-1.65 11.84,-1.65 3.761,0 6.992,0.44 9.672,1.34 2.687,0.9 4.91,2.07 6.66,3.51 1.75,1.46 3.027,3.14 3.84,5.06 0.808,1.92 1.218,3.91 1.218,5.96 0,3.07 -0.918,5.59 -2.757,7.55 -1.832,1.96 -4.262,3.67 -7.293,5.13 -3.039,1.45 -6.489,2.75 -10.379,3.9 -3.879,1.15 -7.852,2.41 -11.899,3.78 -4.07,1.36 -8.031,2.96 -11.91,4.8 -3.883,1.83 -7.34,4.16 -10.371,6.98 -3.031,2.81 -5.469,6.27 -7.309,10.37 -1.832,4.1 -2.75,9.05 -2.75,14.86 0,5.37 1.071,10.49 3.2,15.36 2.14,4.86 5.269,9.11 9.418,12.74 4.14,3.62 9.3,6.53 15.492,8.71 6.199,2.17 13.34,3.26 21.449,3.26 9.051,0 17.281,-1.49 24.719,-4.48 7.422,-2.99 13.601,-6.92 18.562,-11.78 l -7.172,-11.4",
    style: {
      fill: "#254177",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath194)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path195",
    d: "m 854.039,4119.36 v 190.27 h 31.633 v -73.11 c 5.117,4.86 10.758,8.79 16.898,11.78 6.141,2.99 13.352,4.48 21.641,4.48 7.168,0 13.527,-1.22 19.07,-3.65 5.559,-2.43 10.188,-5.85 13.899,-10.24 3.718,-4.4 6.531,-9.65 8.441,-15.75 1.93,-6.11 2.891,-12.82 2.891,-20.17 v -83.61 h -31.621 v 83.61 c 0,8.02 -1.86,14.23 -5.571,18.63 -3.718,4.4 -9.289,6.59 -16.718,6.59 -5.461,0 -10.582,-1.24 -15.372,-3.7 -4.769,-2.48 -9.289,-5.85 -13.558,-10.13 v -95 h -31.633",
    style: {
      fill: "#254177",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)",
    clipPath: "url(#clipPath196)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path197",
    d: "m 778.422,440.91 c 0,-0.832 -0.203,-1.558 -0.621,-2.191 -0.422,-0.617 -1.153,-1.117 -2.192,-1.481 -1.039,-0.359 -2.418,-0.679 -4.14,-0.937 -1.719,-0.262 -3.879,-0.391 -6.481,-0.391 -2.5,0 -4.636,0.129 -6.41,0.391 -1.769,0.258 -3.18,0.578 -4.219,0.937 -1.039,0.364 -1.769,0.864 -2.187,1.481 -0.41,0.633 -0.621,1.359 -0.621,2.191 v 194.059 c 0,0.84 0.23,1.57 0.699,2.191 0.469,0.629 1.25,1.121 2.352,1.488 1.089,0.364 2.5,0.672 4.218,0.93 1.711,0.262 3.77,0.391 6.168,0.391 2.602,0 4.762,-0.129 6.481,-0.391 1.722,-0.258 3.101,-0.566 4.14,-0.93 1.039,-0.367 1.77,-0.859 2.192,-1.488 0.418,-0.621 0.621,-1.351 0.621,-2.191 V 440.91",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path198",
    d: "m 977.949,447.941 c 0,-2.082 -0.347,-3.851 -1.051,-5.312 -0.699,-1.457 -1.617,-2.66 -2.75,-3.59 -1.128,-0.937 -2.398,-1.617 -3.796,-2.027 -1.403,-0.422 -2.801,-0.633 -4.204,-0.633 h -8.886 c -2.801,0 -5.25,0.293 -7.352,0.859 -2.101,0.571 -4.09,1.614 -5.98,3.133 -1.879,1.508 -3.77,3.559 -5.649,6.168 -1.89,2.602 -3.89,5.93 -6.011,10 l -61.68,115 c -3.219,5.93 -6.469,12.16 -9.75,18.672 -3.27,6.508 -6.32,12.84 -9.141,18.98 h -0.32 c 0.211,-7.5 0.371,-15.152 0.473,-22.972 0.109,-7.809 0.16,-15.571 0.16,-23.278 V 440.91 c 0,-0.73 -0.223,-1.43 -0.66,-2.109 -0.442,-0.672 -1.18,-1.199 -2.223,-1.563 -1.051,-0.359 -2.418,-0.679 -4.129,-0.937 -1.699,-0.262 -3.871,-0.391 -6.512,-0.391 -2.636,0 -4.808,0.129 -6.508,0.391 -1.71,0.258 -3.05,0.578 -4.039,0.937 -0.992,0.364 -1.711,0.891 -2.152,1.563 -0.437,0.679 -0.66,1.379 -0.66,2.109 v 186.559 c 0,4.172 1.191,7.14 3.551,8.91 2.371,1.769 4.949,2.66 7.742,2.66 h 13.226 c 3.122,0 5.723,-0.258 7.821,-0.777 2.101,-0.524 3.98,-1.383 5.64,-2.582 1.672,-1.2 3.282,-2.871 4.84,-5 1.563,-2.141 3.199,-4.821 4.91,-8.051 l 47.422,-88.75 c 2.918,-5.418 5.739,-10.699 8.449,-15.859 2.719,-5.149 5.34,-10.231 7.86,-15.231 2.512,-5 5,-9.918 7.469,-14.769 2.472,-4.84 4.91,-9.711 7.32,-14.61 h 0.16 c -0.211,8.231 -0.34,16.801 -0.391,25.711 -0.046,8.899 -0.078,17.469 -0.078,25.699 v 109.692 c 0,0.726 0.219,1.398 0.66,2.027 0.442,0.621 1.18,1.172 2.231,1.641 1.039,0.468 2.41,0.808 4.117,1.011 1.703,0.207 3.934,0.321 6.684,0.321 2.41,0 4.5,-0.114 6.258,-0.321 1.761,-0.203 3.128,-0.543 4.121,-1.011 0.988,-0.469 1.711,-1.02 2.148,-1.641 0.441,-0.629 0.66,-1.301 0.66,-2.027 V 447.941",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path199",
    d: "m 1130.91,627.469 c 0,-1.969 -0.11,-3.688 -0.32,-5.149 -0.2,-1.461 -0.57,-2.629 -1.09,-3.519 -0.52,-0.879 -1.12,-1.531 -1.8,-1.949 -0.67,-0.422 -1.38,-0.633 -2.11,-0.633 h -74.06 v -68.75 h 70 c 0.73,0 1.43,-0.18 2.11,-0.539 0.68,-0.371 1.28,-0.969 1.8,-1.801 0.52,-0.828 0.88,-1.949 1.09,-3.359 0.21,-1.399 0.31,-3.2 0.31,-5.391 0,-1.981 -0.1,-3.668 -0.31,-5.078 -0.21,-1.403 -0.57,-2.551 -1.09,-3.43 -0.52,-0.891 -1.12,-1.57 -1.8,-2.043 -0.68,-0.457 -1.38,-0.699 -2.11,-0.699 h -70 V 440.91 c 0,-0.73 -0.21,-1.43 -0.62,-2.109 -0.42,-0.672 -1.15,-1.199 -2.19,-1.563 -1.04,-0.359 -2.4,-0.679 -4.06,-0.937 -1.67,-0.262 -3.86,-0.391 -6.57,-0.391 -2.5,0 -4.63,0.129 -6.4,0.391 -1.77,0.258 -3.18,0.578 -4.22,0.937 -1.04,0.364 -1.77,0.891 -2.19,1.563 -0.41,0.679 -0.62,1.379 -0.62,2.109 v 187.192 c 0,4.058 1.06,6.898 3.2,8.519 2.14,1.609 4.4,2.418 6.8,2.418 h 90.93 c 0.73,0 1.44,-0.211 2.11,-0.629 0.68,-0.41 1.28,-1.09 1.8,-2.031 0.52,-0.938 0.89,-2.16 1.09,-3.668 0.21,-1.512 0.32,-3.262 0.32,-5.242",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path200",
    d: "m 1331.21,540.289 c 0,-16.359 -1.93,-31.098 -5.78,-44.219 -3.85,-13.129 -9.61,-24.3 -17.27,-33.519 -7.65,-9.223 -17.26,-16.301 -28.82,-21.25 -11.57,-4.949 -25.06,-7.422 -40.47,-7.422 -15.21,0 -28.36,2.269 -39.46,6.801 -11.09,4.531 -20.26,11.121 -27.5,19.761 -7.24,8.649 -12.63,19.379 -16.17,32.188 -3.54,12.812 -5.31,27.551 -5.31,44.223 0,15.937 1.93,30.418 5.78,43.437 3.86,13.02 9.64,24.09 17.34,33.199 7.71,9.114 17.35,16.153 28.91,21.09 11.56,4.953 25.05,7.434 40.47,7.434 14.9,0 27.86,-2.242 38.91,-6.723 11.04,-4.48 20.23,-11.019 27.57,-19.609 7.35,-8.602 12.82,-19.219 16.41,-31.879 3.59,-12.653 5.39,-27.16 5.39,-43.512 z m -28.44,-1.879 c 0,11.461 -1.01,22.11 -3.04,31.961 -2.03,9.84 -5.41,18.379 -10.14,25.617 -4.74,7.242 -11.06,12.891 -18.96,16.953 -7.91,4.071 -17.69,6.098 -29.34,6.098 -11.65,0 -21.43,-2.187 -29.34,-6.57 -7.91,-4.367 -14.33,-10.199 -19.27,-17.5 -4.94,-7.289 -8.48,-15.797 -10.61,-25.539 -2.14,-9.739 -3.2,-19.981 -3.2,-30.711 0,-11.867 0.99,-22.809 2.96,-32.809 1.98,-10 5.31,-18.621 9.99,-25.859 4.68,-7.242 10.95,-12.86 18.8,-16.871 7.86,-4.008 17.72,-6.02 29.58,-6.02 11.75,0 21.64,2.192 29.65,6.559 8.01,4.383 14.46,10.293 19.35,17.742 4.89,7.449 8.37,16.07 10.45,25.859 2.08,9.789 3.12,20.149 3.12,31.09",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path201",
    d: "m 1501.51,440.91 c 0,-0.832 -0.15,-1.558 -0.46,-2.191 -0.32,-0.617 -0.99,-1.141 -2.04,-1.559 -1.04,-0.41 -2.5,-0.73 -4.37,-0.941 -1.88,-0.199 -4.38,-0.309 -7.5,-0.309 -2.71,0 -4.92,0.11 -6.64,0.309 -1.72,0.211 -3.1,0.551 -4.14,1.019 -1.04,0.473 -1.85,1.121 -2.42,1.953 -0.58,0.84 -1.07,1.879 -1.49,3.129 l -18.59,47.649 c -2.19,5.422 -4.45,10.402 -6.8,14.929 -2.34,4.532 -5.13,8.43 -8.36,11.723 -3.23,3.277 -7.03,5.828 -11.4,7.649 -4.38,1.82 -9.64,2.742 -15.79,2.742 h -17.96 V 440.91 c 0,-0.832 -0.24,-1.558 -0.71,-2.191 -0.47,-0.617 -1.2,-1.117 -2.18,-1.481 -0.99,-0.359 -2.35,-0.679 -4.07,-0.937 -1.72,-0.262 -3.88,-0.391 -6.48,-0.391 -2.61,0 -4.77,0.129 -6.49,0.391 -1.71,0.258 -3.09,0.578 -4.14,0.937 -1.04,0.364 -1.77,0.864 -2.18,1.481 -0.42,0.633 -0.63,1.359 -0.63,2.191 v 187.192 c 0,4.058 1.07,6.898 3.2,8.519 2.14,1.609 4.41,2.418 6.8,2.418 h 42.97 c 5.1,0 9.35,-0.129 12.73,-0.391 3.39,-0.257 6.44,-0.546 9.14,-0.859 7.82,-1.359 14.72,-3.488 20.71,-6.41 5.99,-2.918 11.01,-6.609 15.08,-11.09 4.06,-4.48 7.11,-9.609 9.14,-15.391 2.03,-5.777 3.04,-12.16 3.04,-19.136 0,-6.774 -0.91,-12.84 -2.73,-18.211 -1.82,-5.36 -4.45,-10.102 -7.89,-14.223 -3.44,-4.109 -7.55,-7.68 -12.35,-10.699 -4.79,-3.02 -10.15,-5.57 -16.09,-7.66 3.33,-1.449 6.36,-3.297 9.06,-5.539 2.71,-2.239 5.24,-4.918 7.58,-8.051 2.35,-3.117 4.56,-6.719 6.64,-10.777 2.09,-4.063 4.17,-8.653 6.25,-13.75 l 18.13,-44.532 c 1.46,-3.75 2.39,-6.379 2.81,-7.89 0.42,-1.508 0.62,-2.68 0.62,-3.52 z m -40.46,142.031 c 0,7.918 -1.77,14.61 -5.32,20.079 -3.54,5.468 -9.48,9.402 -17.81,11.8 -2.6,0.731 -5.55,1.25 -8.83,1.559 -3.28,0.312 -7.58,0.473 -12.89,0.473 h -22.65 v -68.133 h 26.25 c 7.08,0 13.2,0.859 18.36,2.582 5.15,1.719 9.45,4.121 12.89,7.187 3.43,3.071 5.96,6.692 7.57,10.864 1.62,4.168 2.43,8.699 2.43,13.589",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path202",
    d: "m 1753.22,440.91 c 0,-0.832 -0.21,-1.558 -0.64,-2.191 -0.43,-0.617 -1.18,-1.117 -2.25,-1.481 -1.08,-0.359 -2.44,-0.679 -4.11,-0.937 -1.66,-0.262 -3.83,-0.391 -6.51,-0.391 -2.47,0 -4.59,0.129 -6.36,0.391 -1.77,0.258 -3.16,0.578 -4.18,0.937 -1.02,0.364 -1.75,0.864 -2.18,1.481 -0.43,0.633 -0.64,1.359 -0.64,2.191 v 176.102 h -0.31 l -71.25,-176.883 c -0.32,-0.731 -0.76,-1.348 -1.33,-1.867 -0.57,-0.524 -1.41,-0.973 -2.5,-1.332 -1.09,-0.371 -2.4,-0.629 -3.91,-0.782 -1.51,-0.16 -3.3,-0.238 -5.39,-0.238 -2.19,0 -4.06,0.11 -5.62,0.309 -1.57,0.211 -2.87,0.5 -3.91,0.859 -1.04,0.371 -1.85,0.813 -2.42,1.332 -0.57,0.52 -0.96,1.102 -1.17,1.719 l -68.13,176.883 h -0.15 V 440.91 c 0,-0.832 -0.22,-1.558 -0.65,-2.191 -0.43,-0.617 -1.18,-1.117 -2.25,-1.481 -1.07,-0.359 -2.47,-0.679 -4.19,-0.937 -1.71,-0.262 -3.91,-0.391 -6.59,-0.391 -2.58,0 -4.72,0.129 -6.44,0.391 -1.72,0.258 -3.08,0.578 -4.1,0.937 -1.02,0.364 -1.72,0.864 -2.1,1.481 -0.37,0.633 -0.56,1.359 -0.56,2.191 v 185.942 c 0,4.367 1.16,7.5 3.49,9.367 2.33,1.883 4.92,2.82 7.78,2.82 h 16.5 c 3.38,0 6.34,-0.32 8.88,-0.937 2.54,-0.633 4.76,-1.614 6.67,-2.973 1.9,-1.348 3.49,-3.07 4.75,-5.16 1.27,-2.078 2.39,-4.528 3.34,-7.34 l 57.81,-146.41 h 0.78 l 60.16,145.941 c 1.16,3.129 2.43,5.781 3.81,7.969 1.37,2.191 2.88,3.93 4.52,5.242 1.64,1.301 3.47,2.231 5.48,2.809 2.01,0.57 4.34,0.859 6.98,0.859 h 17.31 c 1.58,0 3.09,-0.238 4.52,-0.711 1.43,-0.457 2.65,-1.187 3.65,-2.18 1.01,-0.988 1.83,-2.238 2.46,-3.75 0.64,-1.507 0.95,-3.359 0.95,-5.546 V 440.91",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path203",
    d: "m 1951.34,446.379 c 0.83,-2.289 1.28,-4.141 1.33,-5.551 0.05,-1.398 -0.34,-2.469 -1.17,-3.199 -0.84,-0.731 -2.22,-1.199 -4.14,-1.41 -1.93,-0.199 -4.51,-0.309 -7.74,-0.309 -3.23,0 -5.81,0.078 -7.73,0.238 -1.93,0.153 -3.39,0.411 -4.38,0.782 -0.99,0.359 -1.72,0.859 -2.18,1.48 -0.47,0.629 -0.92,1.41 -1.33,2.352 l -17.35,49.207 h -84.06 l -16.56,-48.59 c -0.31,-0.938 -0.73,-1.738 -1.25,-2.418 -0.52,-0.68 -1.28,-1.25 -2.27,-1.723 -0.99,-0.468 -2.39,-0.808 -4.22,-1.019 -1.82,-0.199 -4.19,-0.309 -7.11,-0.309 -3.02,0 -5.49,0.129 -7.42,0.391 -1.92,0.258 -3.28,0.758 -4.06,1.488 -0.78,0.731 -1.15,1.789 -1.09,3.199 0.05,1.41 0.49,3.262 1.32,5.551 l 67.82,187.813 c 0.41,1.148 0.96,2.078 1.64,2.808 0.67,0.731 1.66,1.301 2.97,1.719 1.3,0.422 2.97,0.699 5,0.859 2.03,0.16 4.61,0.231 7.73,0.231 3.33,0 6.09,-0.071 8.28,-0.231 2.19,-0.16 3.96,-0.437 5.31,-0.859 1.36,-0.418 2.4,-1.008 3.13,-1.801 0.73,-0.777 1.3,-1.738 1.72,-2.887 z m -87.03,165.781 h -0.16 l -34.84,-100.781 h 70.31 l -35.31,100.781",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path204",
    d: "m 2079.77,627.469 c 0,-1.969 -0.1,-3.688 -0.31,-5.149 -0.21,-1.461 -0.55,-2.629 -1.02,-3.519 -0.47,-0.879 -1.04,-1.531 -1.72,-1.949 -0.67,-0.422 -1.43,-0.633 -2.26,-0.633 h -56.88 V 440.91 c 0,-0.832 -0.21,-1.558 -0.62,-2.191 -0.42,-0.617 -1.15,-1.117 -2.19,-1.481 -1.04,-0.359 -2.42,-0.679 -4.14,-0.937 -1.72,-0.262 -3.88,-0.391 -6.49,-0.391 -2.5,0 -4.63,0.129 -6.4,0.391 -1.77,0.258 -3.18,0.578 -4.22,0.937 -1.04,0.364 -1.77,0.864 -2.19,1.481 -0.41,0.633 -0.62,1.359 -0.62,2.191 v 175.309 h -56.88 c -0.83,0 -1.59,0.211 -2.26,0.633 -0.68,0.418 -1.23,1.07 -1.64,1.949 -0.42,0.89 -0.76,2.058 -1.02,3.519 -0.26,1.461 -0.39,3.18 -0.39,5.149 0,1.98 0.13,3.73 0.39,5.242 0.26,1.508 0.6,2.73 1.02,3.668 0.41,0.941 0.96,1.621 1.64,2.031 0.67,0.418 1.43,0.629 2.26,0.629 h 140.63 c 0.83,0 1.59,-0.211 2.26,-0.629 0.68,-0.41 1.25,-1.09 1.72,-2.031 0.47,-0.938 0.81,-2.16 1.02,-3.668 0.21,-1.512 0.31,-3.262 0.31,-5.242",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path205",
    d: "m 2128.82,440.91 c 0,-0.832 -0.2,-1.558 -0.62,-2.191 -0.42,-0.617 -1.15,-1.117 -2.19,-1.481 -1.04,-0.359 -2.42,-0.679 -4.14,-0.937 -1.72,-0.262 -3.88,-0.391 -6.48,-0.391 -2.5,0 -4.64,0.129 -6.41,0.391 -1.77,0.258 -3.18,0.578 -4.22,0.937 -1.04,0.364 -1.77,0.864 -2.19,1.481 -0.41,0.633 -0.62,1.359 -0.62,2.191 v 194.059 c 0,0.84 0.23,1.57 0.7,2.191 0.47,0.629 1.25,1.121 2.35,1.488 1.09,0.364 2.5,0.672 4.21,0.93 1.72,0.262 3.78,0.391 6.18,0.391 2.6,0 4.76,-0.129 6.48,-0.391 1.72,-0.258 3.1,-0.566 4.14,-0.93 1.04,-0.367 1.77,-0.859 2.19,-1.488 0.42,-0.621 0.62,-1.351 0.62,-2.191 V 440.91",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path206",
    d: "m 2344.91,540.289 c 0,-16.359 -1.93,-31.098 -5.78,-44.219 -3.86,-13.129 -9.61,-24.3 -17.27,-33.519 -7.65,-9.223 -17.26,-16.301 -28.83,-21.25 -11.56,-4.949 -25.05,-7.422 -40.47,-7.422 -15.2,0 -28.35,2.269 -39.45,6.801 -11.09,4.531 -20.26,11.121 -27.5,19.761 -7.24,8.649 -12.63,19.379 -16.17,32.188 -3.54,12.812 -5.31,27.551 -5.31,44.223 0,15.937 1.92,30.418 5.78,43.437 3.85,13.02 9.63,24.09 17.34,33.199 7.71,9.114 17.35,16.153 28.91,21.09 11.56,4.953 25.05,7.434 40.47,7.434 14.89,0 27.86,-2.242 38.9,-6.723 11.05,-4.48 20.24,-11.019 27.58,-19.609 7.35,-8.602 12.81,-19.219 16.41,-31.879 3.59,-12.653 5.39,-27.16 5.39,-43.512 z m -28.44,-1.879 c 0,11.461 -1.01,22.11 -3.04,31.961 -2.03,9.84 -5.41,18.379 -10.15,25.617 -4.73,7.242 -11.05,12.891 -18.96,16.953 -7.9,4.071 -17.68,6.098 -29.33,6.098 -11.66,0 -21.43,-2.187 -29.34,-6.57 -7.91,-4.367 -14.33,-10.199 -19.27,-17.5 -4.95,-7.289 -8.48,-15.797 -10.62,-25.539 -2.13,-9.739 -3.2,-19.981 -3.2,-30.711 0,-11.867 0.99,-22.809 2.97,-32.809 1.98,-10 5.31,-18.621 9.99,-25.859 4.68,-7.242 10.95,-12.86 18.8,-16.871 7.86,-4.008 17.71,-6.02 29.57,-6.02 11.76,0 21.64,2.192 29.65,6.559 8.01,4.383 14.46,10.293 19.35,17.742 4.89,7.449 8.38,16.07 10.46,25.859 2.08,9.789 3.12,20.149 3.12,31.09",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path207",
    d: "m 2533.18,447.941 c 0,-2.082 -0.35,-3.851 -1.05,-5.312 -0.7,-1.457 -1.61,-2.66 -2.75,-3.59 -1.13,-0.937 -2.39,-1.617 -3.79,-2.027 -1.4,-0.422 -2.8,-0.633 -4.21,-0.633 h -8.88 c -2.8,0 -5.25,0.293 -7.36,0.859 -2.1,0.571 -4.09,1.614 -5.98,3.133 -1.88,1.508 -3.77,3.559 -5.65,6.168 -1.89,2.602 -3.89,5.93 -6,10 l -61.68,115 c -3.23,5.93 -6.48,12.16 -9.75,18.672 -3.28,6.508 -6.33,12.84 -9.15,18.98 h -0.31 c 0.21,-7.5 0.36,-15.152 0.47,-22.972 0.1,-7.809 0.15,-15.571 0.15,-23.278 V 440.91 c 0,-0.73 -0.22,-1.43 -0.66,-2.109 -0.44,-0.672 -1.18,-1.199 -2.22,-1.563 -1.05,-0.359 -2.42,-0.679 -4.12,-0.937 -1.71,-0.262 -3.88,-0.391 -6.52,-0.391 -2.64,0 -4.81,0.129 -6.51,0.391 -1.7,0.258 -3.05,0.578 -4.04,0.937 -0.99,0.364 -1.7,0.891 -2.14,1.563 -0.44,0.679 -0.66,1.379 -0.66,2.109 v 186.559 c 0,4.172 1.18,7.14 3.55,8.91 2.36,1.769 4.94,2.66 7.74,2.66 h 13.22 c 3.12,0 5.73,-0.258 7.82,-0.777 2.1,-0.524 3.98,-1.383 5.65,-2.582 1.66,-1.2 3.28,-2.871 4.84,-5 1.56,-2.141 3.19,-4.821 4.9,-8.051 l 47.42,-88.75 c 2.92,-5.418 5.74,-10.699 8.46,-15.859 2.72,-5.149 5.33,-10.231 7.85,-15.231 2.52,-5 5.01,-9.918 7.47,-14.769 2.47,-4.84 4.91,-9.711 7.33,-14.61 h 0.15 c -0.2,8.231 -0.33,16.801 -0.39,25.711 -0.05,8.899 -0.07,17.469 -0.07,25.699 v 109.692 c 0,0.726 0.22,1.398 0.66,2.027 0.43,0.621 1.18,1.172 2.22,1.641 1.04,0.468 2.42,0.808 4.12,1.011 1.71,0.207 3.93,0.321 6.68,0.321 2.42,0 4.51,-0.114 6.27,-0.321 1.75,-0.203 3.13,-0.543 4.12,-1.011 0.99,-0.469 1.7,-1.02 2.14,-1.641 0.44,-0.629 0.66,-1.301 0.66,-2.027 V 447.941",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path208",
    d: "m 2753.79,493.57 c 0,-9.48 -1.75,-17.922 -5.24,-25.308 -3.49,-7.403 -8.33,-13.684 -14.53,-18.832 -6.2,-5.16 -13.49,-9.039 -21.87,-11.641 -8.39,-2.609 -17.42,-3.91 -27.11,-3.91 -6.77,0 -13.05,0.57 -18.83,1.723 -5.78,1.148 -10.94,2.546 -15.47,4.218 -4.53,1.668 -8.33,3.379 -11.4,5.149 -3.08,1.781 -5.21,3.293 -6.41,4.543 -1.2,1.25 -2.08,2.828 -2.66,4.758 -0.57,1.929 -0.86,4.511 -0.86,7.742 0,2.289 0.11,4.187 0.32,5.699 0.2,1.508 0.52,2.73 0.93,3.668 0.42,0.941 0.94,1.59 1.57,1.949 0.62,0.371 1.35,0.551 2.18,0.551 1.46,0 3.52,-0.879 6.18,-2.66 2.65,-1.77 6.06,-3.688 10.23,-5.778 4.17,-2.082 9.19,-4.031 15.08,-5.863 5.88,-1.816 12.68,-2.726 20.39,-2.726 5.83,0 11.17,0.777 16.01,2.339 4.85,1.571 9.01,3.778 12.5,6.637 3.49,2.871 6.18,6.383 8.05,10.551 1.88,4.172 2.81,8.91 2.81,14.223 0,5.726 -1.3,10.617 -3.9,14.687 -2.61,4.063 -6.04,7.633 -10.32,10.699 -4.27,3.071 -9.14,5.891 -14.6,8.442 -5.47,2.55 -11.07,5.148 -16.8,7.808 -5.73,2.66 -11.3,5.602 -16.72,8.832 -5.42,3.231 -10.26,7.032 -14.53,11.399 -4.27,4.383 -7.74,9.511 -10.39,15.402 -2.66,5.879 -3.99,12.938 -3.99,21.168 0,8.43 1.54,15.961 4.61,22.582 3.08,6.609 7.35,12.16 12.82,16.641 5.46,4.476 11.97,7.886 19.53,10.226 7.55,2.34 15.7,3.524 24.45,3.524 4.48,0 8.98,-0.391 13.52,-1.184 4.53,-0.777 8.8,-1.816 12.81,-3.117 4.01,-1.301 7.58,-2.762 10.7,-4.383 3.13,-1.609 5.18,-2.906 6.17,-3.898 0.99,-0.989 1.64,-1.77 1.96,-2.352 0.31,-0.566 0.57,-1.297 0.78,-2.18 0.21,-0.886 0.36,-1.957 0.47,-3.207 0.1,-1.25 0.15,-2.863 0.15,-4.839 0,-1.883 -0.08,-3.543 -0.23,-5 -0.16,-1.461 -0.39,-2.68 -0.71,-3.672 -0.31,-0.989 -0.75,-1.719 -1.32,-2.192 -0.58,-0.468 -1.23,-0.699 -1.96,-0.699 -1.14,0 -2.94,0.731 -5.39,2.18 -2.45,1.461 -5.44,3.101 -8.98,4.929 -3.54,1.821 -7.74,3.493 -12.58,5 -4.84,1.512 -10.29,2.262 -16.33,2.262 -5.62,0 -10.52,-0.75 -14.69,-2.262 -4.16,-1.507 -7.6,-3.519 -10.31,-6.019 -2.71,-2.5 -4.74,-5.469 -6.09,-8.91 -1.36,-3.43 -2.03,-7.078 -2.03,-10.93 0,-5.629 1.3,-10.469 3.9,-14.527 2.61,-4.071 6.07,-7.66 10.39,-10.793 4.33,-3.117 9.25,-5.981 14.77,-8.59 5.52,-2.598 11.15,-5.231 16.87,-7.891 5.73,-2.66 11.36,-5.566 16.88,-8.75 5.52,-3.179 10.44,-6.929 14.77,-11.25 4.32,-4.316 7.81,-9.429 10.46,-15.308 2.66,-5.891 3.99,-12.84 3.99,-20.86",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path209",
    d: "m 2897.69,447.941 c 0,-1.871 -0.11,-3.511 -0.32,-4.921 -0.2,-1.399 -0.57,-2.579 -1.09,-3.508 -0.52,-0.942 -1.12,-1.621 -1.8,-2.043 -0.67,-0.41 -1.43,-0.617 -2.26,-0.617 h -97.03 c -2.4,0 -4.67,0.808 -6.8,2.418 -2.14,1.621 -3.2,4.449 -3.2,8.519 v 180.313 c 0,4.058 1.06,6.898 3.2,8.519 2.13,1.609 4.4,2.418 6.8,2.418 h 95.93 c 0.84,0 1.59,-0.211 2.27,-0.629 0.68,-0.41 1.22,-1.09 1.64,-2.031 0.42,-0.938 0.75,-2.109 1.02,-3.508 0.26,-1.41 0.39,-3.16 0.39,-5.242 0,-1.867 -0.13,-3.508 -0.39,-4.918 -0.27,-1.41 -0.6,-2.551 -1.02,-3.441 -0.42,-0.879 -0.96,-1.532 -1.64,-1.95 -0.68,-0.422 -1.43,-0.629 -2.27,-0.629 h -79.06 v -63.429 h 67.81 c 0.84,0 1.59,-0.242 2.27,-0.711 0.68,-0.473 1.25,-1.121 1.72,-1.949 0.47,-0.832 0.81,-1.981 1.01,-3.442 0.21,-1.461 0.32,-3.172 0.32,-5.148 0,-1.883 -0.11,-3.492 -0.32,-4.852 -0.2,-1.351 -0.54,-2.449 -1.01,-3.281 -0.47,-0.828 -1.04,-1.43 -1.72,-1.801 -0.68,-0.359 -1.43,-0.539 -2.27,-0.539 h -67.81 v -72.348 h 80.16 c 0.83,0 1.59,-0.203 2.26,-0.621 0.68,-0.422 1.28,-1.07 1.8,-1.949 0.52,-0.891 0.89,-2.043 1.09,-3.441 0.21,-1.41 0.32,-3.149 0.32,-5.239",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path210",
    d: "m 3065.65,465.441 c 0,-1.66 -0.06,-3.121 -0.16,-4.371 -0.1,-1.25 -0.29,-2.351 -0.55,-3.281 -0.26,-0.937 -0.6,-1.769 -1.01,-2.5 -0.42,-0.73 -1.15,-1.617 -2.19,-2.66 -1.04,-1.039 -3.23,-2.629 -6.56,-4.758 -3.34,-2.141 -7.48,-4.223 -12.42,-6.25 -4.95,-2.043 -10.63,-3.75 -17.04,-5.16 -6.4,-1.41 -13.41,-2.109 -21.01,-2.109 -13.13,0 -24.98,2.187 -35.55,6.558 -10.57,4.379 -19.58,10.84 -27.03,19.379 -7.45,8.539 -13.18,19.09 -17.19,31.641 -4.01,12.55 -6.01,27 -6.01,43.359 0,16.77 2.16,31.723 6.48,44.84 4.32,13.133 10.39,24.25 18.2,33.359 7.82,9.114 17.17,16.071 28.05,20.864 10.89,4.789 22.94,7.187 36.17,7.187 5.84,0 11.51,-0.551 17.03,-1.641 5.53,-1.097 10.63,-2.476 15.32,-4.136 4.68,-1.672 8.85,-3.602 12.5,-5.793 3.64,-2.18 6.17,-3.981 7.58,-5.391 1.4,-1.398 2.31,-2.469 2.73,-3.199 0.42,-0.731 0.75,-1.59 1.02,-2.578 0.26,-0.992 0.46,-2.16 0.62,-3.512 0.16,-1.359 0.23,-2.969 0.23,-4.848 0,-2.082 -0.1,-3.851 -0.31,-5.312 -0.21,-1.457 -0.52,-2.68 -0.94,-3.668 -0.42,-0.992 -0.92,-1.723 -1.49,-2.191 -0.58,-0.469 -1.29,-0.7 -2.13,-0.7 -1.46,0 -3.5,1.008 -6.12,3.051 -2.62,2.027 -6,4.27 -10.13,6.707 -4.14,2.453 -9.17,4.692 -15.08,6.723 -5.92,2.027 -13.01,3.051 -21.29,3.051 -9.01,0 -17.2,-1.801 -24.58,-5.391 -7.39,-3.59 -13.7,-8.883 -18.93,-15.859 -5.24,-6.981 -9.3,-15.5 -12.18,-25.551 -2.88,-10.051 -4.32,-21.531 -4.32,-34.449 0,-12.813 1.39,-24.141 4.17,-33.981 2.77,-9.851 6.75,-18.082 11.94,-24.691 5.18,-6.621 11.54,-11.621 19.08,-15 7.54,-3.391 16.08,-5.078 25.61,-5.078 8.06,0 15.1,0.988 21.12,2.968 6.02,1.981 11.15,4.192 15.4,6.641 4.24,2.449 7.72,4.66 10.44,6.641 2.72,1.976 4.87,2.968 6.44,2.968 0.74,0 1.36,-0.16 1.89,-0.468 0.52,-0.313 0.94,-0.911 1.25,-1.801 0.32,-0.879 0.55,-2.11 0.71,-3.672 0.16,-1.559 0.24,-3.539 0.24,-5.938",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path211",
    d: "m 3246.26,511.539 c 0,-12.289 -1.79,-23.258 -5.39,-32.891 -3.59,-9.636 -8.72,-17.789 -15.39,-24.457 -6.67,-6.66 -14.79,-11.722 -24.37,-15.152 -9.59,-3.437 -20.47,-5.16 -32.66,-5.16 -11.15,0 -21.3,1.621 -30.47,4.84 -9.17,3.23 -17.03,8 -23.59,14.301 -6.57,6.3 -11.62,14.191 -15.16,23.671 -3.54,9.481 -5.31,20.418 -5.31,32.821 v 125.457 c 0,0.84 0.21,1.57 0.62,2.191 0.42,0.629 1.15,1.121 2.19,1.488 1.04,0.364 2.4,0.672 4.06,0.93 1.67,0.262 3.86,0.391 6.57,0.391 2.5,0 4.63,-0.129 6.4,-0.391 1.77,-0.258 3.15,-0.566 4.14,-0.93 0.99,-0.367 1.7,-0.859 2.11,-1.488 0.42,-0.621 0.63,-1.351 0.63,-2.191 v -122.18 c 0,-9.379 1.14,-17.551 3.43,-24.527 2.3,-6.981 5.6,-12.793 9.93,-17.434 4.32,-4.629 9.53,-8.117 15.62,-10.457 6.1,-2.351 12.94,-3.519 20.55,-3.519 7.81,0 14.76,1.148 20.86,3.437 6.09,2.289 11.25,5.731 15.47,10.313 4.22,4.578 7.44,10.257 9.68,17.027 2.24,6.769 3.36,14.691 3.36,23.75 v 123.59 c 0,0.84 0.21,1.57 0.63,2.191 0.42,0.629 1.14,1.121 2.19,1.488 1.04,0.364 2.42,0.672 4.14,0.93 1.72,0.262 3.88,0.391 6.48,0.391 2.5,0 4.61,-0.129 6.33,-0.391 1.72,-0.258 3.07,-0.566 4.06,-0.93 0.99,-0.367 1.72,-0.859 2.19,-1.488 0.47,-0.621 0.7,-1.351 0.7,-2.191 v -123.43",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path212",
    d: "m 3427.35,440.91 c 0,-0.832 -0.16,-1.558 -0.47,-2.191 -0.31,-0.617 -0.99,-1.141 -2.03,-1.559 -1.04,-0.41 -2.5,-0.73 -4.38,-0.941 -1.87,-0.199 -4.37,-0.309 -7.5,-0.309 -2.71,0 -4.92,0.11 -6.64,0.309 -1.72,0.211 -3.1,0.551 -4.14,1.019 -1.04,0.473 -1.85,1.121 -2.42,1.953 -0.57,0.84 -1.07,1.879 -1.49,3.129 l -18.59,47.649 c -2.19,5.422 -4.45,10.402 -6.8,14.929 -2.34,4.532 -5.13,8.43 -8.36,11.723 -3.22,3.277 -7.03,5.828 -11.4,7.649 -4.38,1.82 -9.64,2.742 -15.78,2.742 h -17.97 V 440.91 c 0,-0.832 -0.24,-1.558 -0.7,-2.191 -0.47,-0.617 -1.2,-1.117 -2.19,-1.481 -0.99,-0.359 -2.35,-0.679 -4.06,-0.937 -1.72,-0.262 -3.88,-0.391 -6.49,-0.391 -2.6,0 -4.76,0.129 -6.48,0.391 -1.72,0.258 -3.1,0.578 -4.14,0.937 -1.05,0.364 -1.77,0.864 -2.19,1.481 -0.42,0.633 -0.63,1.359 -0.63,2.191 v 187.192 c 0,4.058 1.07,6.898 3.21,8.519 2.13,1.609 4.4,2.418 6.79,2.418 h 42.97 c 5.11,0 9.35,-0.129 12.74,-0.391 3.38,-0.257 6.43,-0.546 9.14,-0.859 7.81,-1.359 14.71,-3.488 20.7,-6.41 5.99,-2.918 11.02,-6.609 15.08,-11.09 4.06,-4.48 7.11,-9.609 9.14,-15.391 2.03,-5.777 3.05,-12.16 3.05,-19.136 0,-6.774 -0.92,-12.84 -2.74,-18.211 -1.82,-5.36 -4.45,-10.102 -7.89,-14.223 -3.44,-4.109 -7.55,-7.68 -12.34,-10.699 -4.79,-3.02 -10.16,-5.57 -16.1,-7.66 3.34,-1.449 6.36,-3.297 9.07,-5.539 2.7,-2.239 5.23,-4.918 7.57,-8.051 2.35,-3.117 4.56,-6.719 6.64,-10.777 2.09,-4.063 4.17,-8.653 6.25,-13.75 l 18.13,-44.532 c 1.46,-3.75 2.4,-6.379 2.81,-7.89 0.42,-1.508 0.63,-2.68 0.63,-3.52 z m -40.47,142.031 c 0,7.918 -1.77,14.61 -5.31,20.079 -3.55,5.468 -9.48,9.402 -17.82,11.8 -2.6,0.731 -5.54,1.25 -8.82,1.559 -3.29,0.312 -7.58,0.473 -12.9,0.473 h -22.65 v -68.133 h 26.25 c 7.08,0 13.2,0.859 18.36,2.582 5.15,1.719 9.45,4.121 12.89,7.187 3.44,3.071 5.96,6.692 7.58,10.864 1.61,4.168 2.42,8.699 2.42,13.589",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path213",
    d: "m 3486.09,440.91 c 0,-0.832 -0.21,-1.558 -0.63,-2.191 -0.41,-0.617 -1.14,-1.117 -2.18,-1.481 -1.05,-0.359 -2.43,-0.679 -4.14,-0.937 -1.72,-0.262 -3.88,-0.391 -6.49,-0.391 -2.5,0 -4.63,0.129 -6.41,0.391 -1.77,0.258 -3.17,0.578 -4.21,0.937 -1.05,0.364 -1.77,0.864 -2.19,1.481 -0.42,0.633 -0.63,1.359 -0.63,2.191 v 194.059 c 0,0.84 0.24,1.57 0.71,2.191 0.47,0.629 1.25,1.121 2.34,1.488 1.09,0.364 2.5,0.672 4.22,0.93 1.72,0.262 3.78,0.391 6.17,0.391 2.61,0 4.77,-0.129 6.49,-0.391 1.71,-0.258 3.09,-0.566 4.14,-0.93 1.04,-0.367 1.77,-0.859 2.18,-1.488 0.42,-0.621 0.63,-1.351 0.63,-2.191 V 440.91",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path214",
    d: "m 3659.52,627.469 c 0,-1.969 -0.11,-3.688 -0.32,-5.149 -0.2,-1.461 -0.54,-2.629 -1.01,-3.519 -0.47,-0.879 -1.04,-1.531 -1.72,-1.949 -0.68,-0.422 -1.43,-0.633 -2.27,-0.633 h -56.87 V 440.91 c 0,-0.832 -0.21,-1.558 -0.63,-2.191 -0.41,-0.617 -1.14,-1.117 -2.18,-1.481 -1.04,-0.359 -2.42,-0.679 -4.14,-0.937 -1.72,-0.262 -3.88,-0.391 -6.49,-0.391 -2.5,0 -4.63,0.129 -6.4,0.391 -1.77,0.258 -3.18,0.578 -4.22,0.937 -1.04,0.364 -1.77,0.864 -2.19,1.481 -0.42,0.633 -0.63,1.359 -0.63,2.191 v 175.309 h -56.87 c -0.83,0 -1.59,0.211 -2.27,0.633 -0.67,0.418 -1.22,1.07 -1.64,1.949 -0.41,0.89 -0.75,2.058 -1.01,3.519 -0.26,1.461 -0.39,3.18 -0.39,5.149 0,1.98 0.13,3.73 0.39,5.242 0.26,1.508 0.6,2.73 1.01,3.668 0.42,0.941 0.97,1.621 1.64,2.031 0.68,0.418 1.44,0.629 2.27,0.629 h 140.62 c 0.84,0 1.59,-0.211 2.27,-0.629 0.68,-0.41 1.25,-1.09 1.72,-2.031 0.47,-0.938 0.81,-2.16 1.01,-3.668 0.21,-1.512 0.32,-3.262 0.32,-5.242",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path215",
    d: "M 3746.07,515.441 V 440.91 c 0,-0.832 -0.21,-1.558 -0.62,-2.191 -0.41,-0.617 -1.14,-1.117 -2.18,-1.481 -1.03,-0.359 -2.43,-0.679 -4.19,-0.937 -1.76,-0.262 -3.88,-0.391 -6.37,-0.391 -2.59,0 -4.74,0.129 -6.45,0.391 -1.71,0.258 -3.1,0.578 -4.19,0.937 -1.09,0.364 -1.84,0.864 -2.25,1.481 -0.42,0.633 -0.62,1.359 -0.62,2.191 v 74.531 l -57.19,114.071 c -1.15,2.386 -1.85,4.269 -2.11,5.617 -0.26,1.359 0,2.402 0.78,3.133 0.78,0.726 2.19,1.187 4.22,1.398 2.03,0.211 4.76,0.309 8.2,0.309 3.13,0 5.65,-0.098 7.58,-0.309 1.93,-0.211 3.46,-0.488 4.61,-0.859 1.15,-0.36 2,-0.879 2.58,-1.563 0.57,-0.679 1.12,-1.539 1.64,-2.578 l 27.97,-58.121 c 2.59,-5.519 5.19,-11.301 7.77,-17.348 2.59,-6.043 5.23,-12.132 7.93,-18.281 h 0.31 c 2.38,5.942 4.84,11.852 7.38,17.738 2.53,5.883 5.1,11.692 7.7,17.422 l 28.13,58.442 c 0.31,1.039 0.75,1.918 1.32,2.648 0.58,0.731 1.36,1.281 2.35,1.641 0.99,0.371 2.37,0.648 4.14,0.859 1.77,0.211 4.01,0.309 6.72,0.309 3.75,0 6.69,-0.129 8.83,-0.391 2.13,-0.258 3.62,-0.75 4.45,-1.476 0.83,-0.731 1.12,-1.774 0.86,-3.133 -0.26,-1.348 -0.97,-3.168 -2.11,-5.457 l -57.19,-114.071",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path216",
    d: "m 1546.82,140.289 c 0,-0.84 -0.22,-1.57 -0.64,-2.187 -0.43,-0.633 -1.18,-1.122 -2.26,-1.481 -1.07,-0.371 -2.44,-0.68 -4.1,-0.941 -1.66,-0.258 -3.84,-0.391 -6.52,-0.391 -2.47,0 -4.59,0.133 -6.36,0.391 -1.77,0.261 -3.16,0.57 -4.18,0.941 -1.02,0.359 -1.74,0.848 -2.17,1.481 -0.43,0.617 -0.65,1.347 -0.65,2.187 v 176.09 h -0.31 l -71.25,-176.867 c -0.31,-0.731 -0.75,-1.364 -1.33,-1.883 -0.57,-0.52 -1.4,-0.957 -2.5,-1.328 -1.09,-0.36 -2.39,-0.621 -3.9,-0.781 -1.51,-0.149 -3.31,-0.231 -5.39,-0.231 -2.19,0 -4.07,0.102 -5.63,0.313 -1.56,0.207 -2.86,0.488 -3.91,0.859 -1.04,0.359 -1.84,0.809 -2.42,1.328 -0.57,0.52 -0.96,1.09 -1.17,1.723 l -68.12,176.867 h -0.16 v -176.09 c 0,-0.84 -0.21,-1.57 -0.64,-2.187 -0.43,-0.633 -1.18,-1.122 -2.26,-1.481 -1.07,-0.371 -2.47,-0.68 -4.18,-0.941 -1.72,-0.258 -3.92,-0.391 -6.6,-0.391 -2.57,0 -4.72,0.133 -6.44,0.391 -1.71,0.261 -3.08,0.57 -4.1,0.941 -1.02,0.359 -1.72,0.848 -2.09,1.481 -0.38,0.617 -0.57,1.347 -0.57,2.187 v 185.93 c 0,4.383 1.17,7.5 3.49,9.383 2.33,1.867 4.92,2.808 7.78,2.808 h 16.5 c 3.38,0 6.35,-0.308 8.89,-0.941 2.53,-0.617 4.76,-1.61 6.66,-2.957 1.9,-1.364 3.49,-3.082 4.76,-5.16 1.27,-2.082 2.38,-4.532 3.33,-7.34 l 57.81,-146.41 h 0.78 l 60.16,145.937 c 1.16,3.121 2.43,5.781 3.81,7.973 1.38,2.179 2.89,3.929 4.53,5.226 1.64,1.301 3.46,2.242 5.47,2.813 2.01,0.578 4.34,0.859 6.99,0.859 h 17.3 c 1.59,0 3.1,-0.23 4.52,-0.699 1.43,-0.473 2.65,-1.199 3.66,-2.191 1,-0.989 1.82,-2.239 2.46,-3.75 0.63,-1.508 0.95,-3.36 0.95,-5.551 v -185.93",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path217",
    d: "m 1744.93,145.762 c 0.84,-2.301 1.28,-4.141 1.33,-5.551 0.05,-1.41 -0.34,-2.473 -1.17,-3.199 -0.83,-0.731 -2.21,-1.203 -4.14,-1.41 -1.93,-0.211 -4.5,-0.313 -7.73,-0.313 -3.23,0 -5.81,0.082 -7.74,0.231 -1.93,0.16 -3.38,0.421 -4.37,0.781 -0.99,0.371 -1.72,0.859 -2.19,1.488 -0.47,0.621 -0.91,1.402 -1.33,2.34 l -17.34,49.223 h -84.07 l -16.56,-48.59 c -0.31,-0.942 -0.73,-1.75 -1.25,-2.434 -0.52,-0.668 -1.27,-1.25 -2.26,-1.707 -0.99,-0.473 -2.4,-0.812 -4.22,-1.019 -1.83,-0.211 -4.19,-0.313 -7.11,-0.313 -3.02,0 -5.5,0.133 -7.42,0.391 -1.93,0.261 -3.28,0.75 -4.07,1.48 -0.78,0.731 -1.14,1.801 -1.09,3.211 0.05,1.399 0.5,3.25 1.33,5.539 l 67.81,187.809 c 0.42,1.152 0.96,2.09 1.64,2.82 0.68,0.731 1.67,1.301 2.97,1.723 1.3,0.41 2.97,0.699 5,0.859 2.03,0.149 4.61,0.231 7.73,0.231 3.34,0 6.1,-0.082 8.29,-0.231 2.18,-0.16 3.95,-0.449 5.31,-0.859 1.35,-0.422 2.39,-1.024 3.12,-1.801 0.73,-0.781 1.31,-1.75 1.72,-2.891 z m -87.03,165.777 h -0.15 L 1622.9,210.762 h 70.32 l -35.32,100.777",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path218",
    d: "m 1924.46,147.32 c 0,-2.082 -0.35,-3.859 -1.05,-5.308 -0.7,-1.461 -1.62,-2.66 -2.75,-3.602 -1.13,-0.941 -2.4,-1.609 -3.8,-2.031 -1.4,-0.418 -2.8,-0.617 -4.2,-0.617 h -8.89 c -2.8,0 -5.25,0.277 -7.35,0.859 -2.1,0.57 -4.09,1.609 -5.98,3.117 -1.88,1.512 -3.77,3.571 -5.65,6.172 -1.89,2.61 -3.89,5.942 -6.01,10 l -61.68,115 c -3.22,5.942 -6.47,12.16 -9.75,18.668 -3.27,6.512 -6.32,12.844 -9.14,18.992 h -0.32 c 0.21,-7.5 0.37,-15.16 0.47,-22.968 0.11,-7.813 0.16,-15.571 0.16,-23.282 V 140.289 c 0,-0.73 -0.22,-1.437 -0.66,-2.109 -0.44,-0.68 -1.18,-1.2 -2.22,-1.559 -1.05,-0.371 -2.42,-0.68 -4.13,-0.941 -1.7,-0.258 -3.87,-0.391 -6.51,-0.391 -2.64,0 -4.81,0.133 -6.51,0.391 -1.71,0.261 -3.05,0.57 -4.04,0.941 -0.99,0.359 -1.71,0.879 -2.15,1.559 -0.44,0.672 -0.66,1.379 -0.66,2.109 v 186.563 c 0,4.168 1.19,7.136 3.55,8.91 2.37,1.769 4.95,2.648 7.74,2.648 h 13.23 c 3.12,0 5.72,-0.262 7.82,-0.781 2.1,-0.52 3.98,-1.379 5.64,-2.578 1.67,-1.199 3.28,-2.86 4.84,-5 1.56,-2.129 3.2,-4.813 4.91,-8.039 l 47.42,-88.75 c 2.92,-5.422 5.74,-10.711 8.45,-15.864 2.72,-5.16 5.34,-10.238 7.86,-15.238 2.51,-5 5,-9.922 7.47,-14.762 2.47,-4.847 4.91,-9.718 7.32,-14.609 h 0.16 c -0.21,8.231 -0.34,16.789 -0.39,25.699 -0.05,8.91 -0.08,17.473 -0.08,25.703 v 109.688 c 0,0.73 0.22,1.41 0.66,2.031 0.44,0.629 1.18,1.168 2.23,1.641 1.04,0.469 2.41,0.808 4.12,1.019 1.7,0.211 3.93,0.309 6.68,0.309 2.41,0 4.5,-0.098 6.26,-0.309 1.76,-0.211 3.13,-0.55 4.12,-1.019 0.99,-0.473 1.71,-1.012 2.15,-1.641 0.44,-0.621 0.66,-1.301 0.66,-2.031 V 147.32",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path219",
    d: "m 2122.57,145.762 c 0.84,-2.301 1.28,-4.141 1.33,-5.551 0.05,-1.41 -0.34,-2.473 -1.17,-3.199 -0.83,-0.731 -2.21,-1.203 -4.14,-1.41 -1.93,-0.211 -4.51,-0.313 -7.74,-0.313 -3.22,0 -5.8,0.082 -7.73,0.231 -1.93,0.16 -3.39,0.421 -4.37,0.781 -0.99,0.371 -1.72,0.859 -2.19,1.488 -0.47,0.621 -0.91,1.402 -1.33,2.34 l -17.34,49.223 h -84.07 l -16.56,-48.59 c -0.31,-0.942 -0.73,-1.75 -1.25,-2.434 -0.52,-0.668 -1.28,-1.25 -2.26,-1.707 -0.99,-0.473 -2.4,-0.812 -4.22,-1.019 -1.83,-0.211 -4.2,-0.313 -7.11,-0.313 -3.02,0 -5.5,0.133 -7.42,0.391 -1.93,0.261 -3.29,0.75 -4.07,1.48 -0.78,0.731 -1.14,1.801 -1.09,3.211 0.05,1.399 0.49,3.25 1.33,5.539 l 67.81,187.809 c 0.42,1.152 0.96,2.09 1.64,2.82 0.68,0.731 1.67,1.301 2.97,1.723 1.3,0.41 2.97,0.699 5,0.859 2.03,0.149 4.61,0.231 7.73,0.231 3.34,0 6.1,-0.082 8.28,-0.231 2.19,-0.16 3.96,-0.449 5.32,-0.859 1.35,-0.422 2.39,-1.024 3.12,-1.801 0.73,-0.781 1.3,-1.75 1.72,-2.891 z m -87.03,165.777 h -0.15 l -34.85,-100.777 h 70.31 l -35.31,100.777",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path220",
    d: "m 2298.81,310.91 c 0,-1.98 -0.1,-3.719 -0.31,-5.23 -0.21,-1.508 -0.52,-2.758 -0.94,-3.75 -0.41,-0.989 -0.93,-1.692 -1.56,-2.11 -0.62,-0.422 -1.3,-0.629 -2.03,-0.629 -1.25,0 -3.33,0.989 -6.25,2.969 -2.92,1.981 -6.82,4.168 -11.72,6.559 -4.89,2.402 -10.75,4.59 -17.58,6.57 -6.82,1.981 -14.92,2.973 -24.29,2.973 -11.15,0 -21.15,-2.043 -30,-6.102 -8.86,-4.058 -16.36,-9.691 -22.5,-16.871 -6.15,-7.187 -10.86,-15.73 -14.14,-25.629 -3.28,-9.89 -4.93,-20.621 -4.93,-32.191 0,-12.91 1.8,-24.367 5.4,-34.367 3.59,-10 8.56,-18.442 14.92,-25.313 6.35,-6.879 13.93,-12.09 22.73,-15.629 8.8,-3.539 18.47,-5.308 28.99,-5.308 6.25,0 12.57,0.75 18.98,2.269 6.41,1.508 12.37,3.77 17.89,6.789 v 58.91 h -46.87 c -1.77,0 -3.1,0.879 -3.99,2.649 -0.88,1.781 -1.33,4.543 -1.33,8.293 0,1.976 0.11,3.668 0.32,5.066 0.2,1.41 0.54,2.563 1.01,3.442 0.47,0.89 1.02,1.539 1.64,1.949 0.63,0.422 1.41,0.633 2.35,0.633 h 64.21 c 1.15,0 2.3,-0.211 3.44,-0.633 1.15,-0.41 2.19,-1.039 3.13,-1.867 0.93,-0.832 1.66,-1.981 2.18,-3.442 0.53,-1.461 0.79,-3.121 0.79,-5 v -77.031 c 0,-2.707 -0.47,-5.051 -1.41,-7.027 -0.94,-1.981 -2.92,-3.723 -5.94,-5.231 -3.02,-1.519 -6.92,-3.16 -11.72,-4.93 -4.79,-1.769 -9.74,-3.281 -14.84,-4.531 -5.1,-1.25 -10.26,-2.191 -15.47,-2.808 -5.21,-0.633 -10.36,-0.942 -15.47,-0.942 -15.62,0 -29.58,2.418 -41.87,7.27 -12.29,4.84 -22.69,11.742 -31.17,20.699 -8.49,8.961 -14.98,19.691 -19.46,32.191 -4.48,12.5 -6.72,26.461 -6.72,41.871 0,16.047 2.43,30.579 7.27,43.598 4.84,13.02 11.67,24.109 20.47,33.281 8.8,9.168 19.37,16.27 31.72,21.328 12.34,5.051 26.01,7.571 41.01,7.571 7.71,0 14.95,-0.668 21.72,-2.028 6.77,-1.351 12.79,-2.941 18.05,-4.761 5.26,-1.828 9.69,-3.801 13.28,-5.942 3.59,-2.136 6.07,-3.879 7.42,-5.226 1.36,-1.364 2.29,-2.922 2.81,-4.692 0.52,-1.769 0.78,-4.32 0.78,-7.66",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path221",
    d: "m 2454.27,147.32 c 0,-1.879 -0.1,-3.519 -0.31,-4.922 -0.21,-1.41 -0.57,-2.578 -1.09,-3.519 -0.52,-0.938 -1.12,-1.609 -1.8,-2.027 -0.68,-0.422 -1.43,-0.633 -2.26,-0.633 h -97.04 c -2.39,0 -4.66,0.812 -6.79,2.429 -2.14,1.614 -3.21,4.454 -3.21,8.512 v 180.309 c 0,4.07 1.07,6.91 3.21,8.519 2.13,1.614 4.4,2.422 6.79,2.422 h 95.94 c 0.84,0 1.59,-0.211 2.27,-0.621 0.67,-0.418 1.22,-1.098 1.64,-2.027 0.42,-0.942 0.75,-2.114 1.01,-3.524 0.26,-1.41 0.39,-3.148 0.39,-5.226 0,-1.883 -0.13,-3.524 -0.39,-4.934 -0.26,-1.398 -0.59,-2.547 -1.01,-3.43 -0.42,-0.886 -0.97,-1.539 -1.64,-1.957 -0.68,-0.41 -1.43,-0.621 -2.27,-0.621 h -79.06 v -63.441 h 67.81 c 0.84,0 1.59,-0.231 2.27,-0.699 0.67,-0.469 1.25,-1.121 1.72,-1.961 0.47,-0.828 0.8,-1.969 1.01,-3.43 0.21,-1.461 0.31,-3.18 0.31,-5.16 0,-1.867 -0.1,-3.488 -0.31,-4.84 -0.21,-1.359 -0.54,-2.449 -1.01,-3.277 -0.47,-0.84 -1.05,-1.442 -1.72,-1.801 -0.68,-0.371 -1.43,-0.551 -2.27,-0.551 h -67.81 v -72.34 h 80.16 c 0.83,0 1.58,-0.211 2.26,-0.629 0.68,-0.41 1.28,-1.062 1.8,-1.953 0.52,-0.886 0.88,-2.027 1.09,-3.437 0.21,-1.403 0.31,-3.153 0.31,-5.231",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path222",
    d: "m 2710.83,140.289 c 0,-0.84 -0.22,-1.57 -0.64,-2.187 -0.43,-0.633 -1.18,-1.122 -2.26,-1.481 -1.07,-0.371 -2.44,-0.68 -4.1,-0.941 -1.66,-0.258 -3.84,-0.391 -6.52,-0.391 -2.47,0 -4.59,0.133 -6.36,0.391 -1.77,0.261 -3.16,0.57 -4.18,0.941 -1.02,0.359 -1.74,0.848 -2.17,1.481 -0.43,0.617 -0.65,1.347 -0.65,2.187 v 176.09 h -0.31 l -71.25,-176.867 c -0.31,-0.731 -0.75,-1.364 -1.33,-1.883 -0.57,-0.52 -1.4,-0.957 -2.5,-1.328 -1.09,-0.36 -2.39,-0.621 -3.9,-0.781 -1.51,-0.149 -3.31,-0.231 -5.39,-0.231 -2.19,0 -4.07,0.102 -5.63,0.313 -1.56,0.207 -2.86,0.488 -3.91,0.859 -1.04,0.359 -1.84,0.809 -2.42,1.328 -0.57,0.52 -0.96,1.09 -1.17,1.723 l -68.12,176.867 h -0.16 v -176.09 c 0,-0.84 -0.21,-1.57 -0.64,-2.187 -0.43,-0.633 -1.18,-1.122 -2.26,-1.481 -1.07,-0.371 -2.47,-0.68 -4.18,-0.941 -1.72,-0.258 -3.92,-0.391 -6.6,-0.391 -2.57,0 -4.72,0.133 -6.44,0.391 -1.71,0.261 -3.08,0.57 -4.1,0.941 -1.02,0.359 -1.72,0.848 -2.09,1.481 -0.38,0.617 -0.57,1.347 -0.57,2.187 v 185.93 c 0,4.383 1.17,7.5 3.49,9.383 2.33,1.867 4.92,2.808 7.78,2.808 h 16.5 c 3.38,0 6.35,-0.308 8.89,-0.941 2.53,-0.617 4.76,-1.61 6.66,-2.957 1.9,-1.364 3.49,-3.082 4.76,-5.16 1.27,-2.082 2.38,-4.532 3.33,-7.34 l 57.81,-146.41 h 0.78 l 60.16,145.937 c 1.16,3.121 2.43,5.781 3.81,7.973 1.38,2.179 2.89,3.929 4.53,5.226 1.64,1.301 3.46,2.242 5.47,2.813 2.01,0.578 4.34,0.859 6.99,0.859 h 17.3 c 1.59,0 3.1,-0.23 4.52,-0.699 1.43,-0.473 2.65,-1.199 3.66,-2.191 1,-0.989 1.82,-2.239 2.46,-3.75 0.63,-1.508 0.95,-3.36 0.95,-5.551 v -185.93",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path223",
    d: "m 2870.04,147.32 c 0,-1.879 -0.11,-3.519 -0.31,-4.922 -0.21,-1.41 -0.58,-2.578 -1.1,-3.519 -0.52,-0.938 -1.12,-1.609 -1.79,-2.027 -0.68,-0.422 -1.44,-0.633 -2.27,-0.633 h -97.03 c -2.4,0 -4.66,0.812 -6.8,2.429 -2.13,1.614 -3.2,4.454 -3.2,8.512 v 180.309 c 0,4.07 1.07,6.91 3.2,8.519 2.14,1.614 4.4,2.422 6.8,2.422 h 95.94 c 0.83,0 1.58,-0.211 2.26,-0.621 0.68,-0.418 1.23,-1.098 1.64,-2.027 0.42,-0.942 0.76,-2.114 1.02,-3.524 0.26,-1.41 0.39,-3.148 0.39,-5.226 0,-1.883 -0.13,-3.524 -0.39,-4.934 -0.26,-1.398 -0.6,-2.547 -1.02,-3.43 -0.41,-0.886 -0.96,-1.539 -1.64,-1.957 -0.68,-0.41 -1.43,-0.621 -2.26,-0.621 h -79.07 v -63.441 h 67.82 c 0.83,0 1.58,-0.231 2.26,-0.699 0.68,-0.469 1.25,-1.121 1.72,-1.961 0.47,-0.828 0.81,-1.969 1.02,-3.43 0.2,-1.461 0.31,-3.18 0.31,-5.16 0,-1.867 -0.11,-3.488 -0.31,-4.84 -0.21,-1.359 -0.55,-2.449 -1.02,-3.277 -0.47,-0.84 -1.04,-1.442 -1.72,-1.801 -0.68,-0.371 -1.43,-0.551 -2.26,-0.551 h -67.82 v -72.34 h 80.16 c 0.83,0 1.59,-0.211 2.27,-0.629 0.67,-0.41 1.27,-1.062 1.79,-1.953 0.52,-0.886 0.89,-2.027 1.1,-3.437 0.2,-1.403 0.31,-3.153 0.31,-5.231",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path224",
    d: "m 3059.56,147.32 c 0,-2.082 -0.35,-3.859 -1.05,-5.308 -0.7,-1.461 -1.61,-2.66 -2.75,-3.602 -1.13,-0.941 -2.39,-1.609 -3.79,-2.031 -1.4,-0.418 -2.8,-0.617 -4.21,-0.617 h -8.88 c -2.8,0 -5.25,0.277 -7.36,0.859 -2.1,0.57 -4.09,1.609 -5.98,3.117 -1.88,1.512 -3.77,3.571 -5.65,6.172 -1.89,2.61 -3.89,5.942 -6,10 l -61.68,115 c -3.23,5.942 -6.48,12.16 -9.75,18.668 -3.28,6.512 -6.33,12.844 -9.15,18.992 H 2933 c 0.21,-7.5 0.36,-15.16 0.47,-22.968 0.1,-7.813 0.15,-15.571 0.15,-23.282 V 140.289 c 0,-0.73 -0.22,-1.437 -0.66,-2.109 -0.44,-0.68 -1.18,-1.2 -2.22,-1.559 -1.05,-0.371 -2.42,-0.68 -4.12,-0.941 -1.71,-0.258 -3.88,-0.391 -6.52,-0.391 -2.64,0 -4.81,0.133 -6.51,0.391 -1.7,0.261 -3.05,0.57 -4.04,0.941 -0.99,0.359 -1.7,0.879 -2.14,1.559 -0.44,0.672 -0.66,1.379 -0.66,2.109 v 186.563 c 0,4.168 1.18,7.136 3.55,8.91 2.36,1.769 4.94,2.648 7.74,2.648 h 13.22 c 3.12,0 5.73,-0.262 7.82,-0.781 2.1,-0.52 3.98,-1.379 5.65,-2.578 1.66,-1.199 3.28,-2.86 4.84,-5 1.56,-2.129 3.19,-4.813 4.9,-8.039 l 47.42,-88.75 c 2.92,-5.422 5.74,-10.711 8.46,-15.864 2.72,-5.16 5.33,-10.238 7.85,-15.238 2.52,-5 5.01,-9.922 7.47,-14.762 2.47,-4.847 4.91,-9.718 7.33,-14.609 h 0.15 c -0.2,8.231 -0.33,16.789 -0.39,25.699 -0.05,8.91 -0.07,17.473 -0.07,25.703 v 109.688 c 0,0.73 0.22,1.41 0.66,2.031 0.43,0.629 1.18,1.168 2.22,1.641 1.04,0.469 2.42,0.808 4.12,1.019 1.71,0.211 3.93,0.309 6.68,0.309 2.42,0 4.51,-0.098 6.27,-0.309 1.75,-0.211 3.13,-0.55 4.12,-1.019 0.99,-0.473 1.7,-1.012 2.14,-1.641 0.44,-0.621 0.66,-1.301 0.66,-2.031 V 147.32",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path225",
    d: "m 3232.99,326.852 c 0,-1.981 -0.1,-3.704 -0.31,-5.161 -0.21,-1.453 -0.55,-2.632 -1.02,-3.511 -0.47,-0.891 -1.04,-1.539 -1.72,-1.961 -0.67,-0.41 -1.43,-0.617 -2.26,-0.617 H 3170.8 V 140.289 c 0,-0.84 -0.21,-1.57 -0.62,-2.187 -0.42,-0.633 -1.15,-1.122 -2.19,-1.481 -1.04,-0.371 -2.42,-0.68 -4.14,-0.941 -1.72,-0.258 -3.88,-0.391 -6.49,-0.391 -2.5,0 -4.63,0.133 -6.4,0.391 -1.77,0.261 -3.18,0.57 -4.22,0.941 -1.04,0.359 -1.77,0.848 -2.19,1.481 -0.41,0.617 -0.62,1.347 -0.62,2.187 v 175.313 h -56.88 c -0.83,0 -1.59,0.207 -2.26,0.617 -0.68,0.422 -1.23,1.07 -1.64,1.961 -0.42,0.879 -0.76,2.058 -1.02,3.511 -0.26,1.457 -0.39,3.18 -0.39,5.161 0,1.976 0.13,3.718 0.39,5.226 0.26,1.512 0.6,2.742 1.02,3.684 0.41,0.929 0.96,1.609 1.64,2.027 0.67,0.41 1.43,0.621 2.26,0.621 h 140.63 c 0.83,0 1.59,-0.211 2.26,-0.621 0.68,-0.418 1.25,-1.098 1.72,-2.027 0.47,-0.942 0.81,-2.172 1.02,-3.684 0.21,-1.508 0.31,-3.25 0.31,-5.226",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path226",
    d: "m 1181.16,752.852 c 0,-1.563 -0.39,-2.93 -1.17,-4.102 -0.78,-1.172 -2.15,-2.102 -4.1,-2.789 -1.96,-0.68 -4.54,-1.27 -7.77,-1.75 -3.22,-0.492 -7.27,-0.742 -12.15,-0.742 -4.69,0 -8.7,0.25 -12.02,0.742 -3.32,0.48 -5.95,1.07 -7.91,1.75 -1.95,0.687 -3.32,1.617 -4.1,2.789 -0.78,1.172 -1.17,2.539 -1.17,4.102 v 363.868 c 0,1.56 0.44,2.93 1.32,4.1 0.88,1.17 2.34,2.1 4.39,2.78 2.05,0.68 4.69,1.27 7.91,1.76 3.23,0.49 7.08,0.73 11.58,0.73 4.88,0 8.93,-0.24 12.15,-0.73 3.23,-0.49 5.81,-1.08 7.77,-1.76 1.95,-0.68 3.32,-1.61 4.1,-2.78 0.78,-1.17 1.17,-2.54 1.17,-4.1 V 752.852",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path227",
    d: "m 1472.36,851.578 c 0,-17.769 -3.28,-33.59 -9.82,-47.457 -6.54,-13.871 -15.62,-25.641 -27.24,-35.301 -11.63,-9.672 -25.3,-16.949 -41.02,-21.832 -15.72,-4.879 -32.67,-7.316 -50.83,-7.316 -12.7,0 -24.46,1.066 -35.3,3.219 -10.84,2.148 -20.51,4.781 -29.01,7.91 -8.49,3.121 -15.62,6.347 -21.38,9.668 -5.77,3.32 -9.77,6.152 -12.02,8.492 -2.24,2.348 -3.9,5.32 -4.98,8.937 -1.07,3.614 -1.61,8.442 -1.61,14.5 0,4.301 0.2,7.864 0.59,10.692 0.39,2.832 0.97,5.129 1.76,6.89 0.78,1.758 1.75,2.981 2.93,3.661 1.17,0.679 2.53,1.031 4.1,1.031 2.73,0 6.59,-1.672 11.57,-4.992 4.98,-3.321 11.38,-6.93 19.19,-10.84 7.81,-3.899 17.24,-7.559 28.27,-10.981 11.04,-3.418 23.78,-5.129 38.23,-5.129 10.94,0 20.95,1.469 30.03,4.399 9.08,2.93 16.9,7.082 23.44,12.449 6.54,5.371 11.57,11.961 15.09,19.774 3.51,7.82 5.27,16.699 5.27,26.66 0,10.738 -2.44,19.918 -7.32,27.539 -4.89,7.621 -11.33,14.308 -19.34,20.07 -8.01,5.758 -17.14,11.039 -27.39,15.82 -10.26,4.789 -20.75,9.668 -31.5,14.649 -10.74,4.98 -21.19,10.5 -31.34,16.551 -10.16,6.058 -19.24,13.187 -27.25,21.39 -8.01,8.199 -14.5,17.821 -19.48,28.86 -4.98,11.029 -7.47,24.259 -7.47,39.689 0,15.82 2.88,29.93 8.64,42.34 5.76,12.4 13.77,22.8 24.02,31.2 10.26,8.4 22.46,14.79 36.62,19.19 14.16,4.39 29.45,6.59 45.85,6.59 8.4,0 16.85,-0.73 25.35,-2.2 8.49,-1.46 16.5,-3.42 24.02,-5.86 7.52,-2.44 14.21,-5.17 20.07,-8.2 5.86,-3.03 9.71,-5.47 11.57,-7.32 1.86,-1.86 3.08,-3.32 3.66,-4.4 0.59,-1.07 1.08,-2.44 1.47,-4.1 0.39,-1.66 0.68,-3.66 0.88,-6.01 0.19,-2.34 0.29,-5.37 0.29,-9.08 0,-3.51 -0.15,-6.64 -0.44,-9.37 -0.29,-2.74 -0.73,-5.03 -1.32,-6.89 -0.58,-1.85 -1.41,-3.22 -2.49,-4.1 -1.07,-0.88 -2.29,-1.32 -3.66,-1.32 -2.15,0 -5.52,1.37 -10.11,4.1 -4.59,2.74 -10.2,5.81 -16.84,9.23 -6.65,3.42 -14.51,6.54 -23.59,9.38 -9.08,2.83 -19.29,4.24 -30.61,4.24 -10.55,0 -19.73,-1.41 -27.54,-4.24 -7.82,-2.84 -14.26,-6.59 -19.34,-11.28 -5.08,-4.69 -8.89,-10.26 -11.42,-16.7 -2.54,-6.45 -3.81,-13.28 -3.81,-20.51 0,-10.55 2.44,-19.63 7.32,-27.25 4.88,-7.61 11.38,-14.348 19.48,-20.211 8.11,-5.86 17.34,-11.231 27.69,-16.11 10.35,-4.89 20.9,-9.82 31.64,-14.801 10.74,-4.976 21.29,-10.449 31.64,-16.398 10.35,-5.961 19.58,-12.988 27.69,-21.102 8.1,-8.097 14.64,-17.668 19.62,-28.707 4.99,-11.031 7.48,-24.07 7.48,-39.113",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path228",
    d: "m 1848.8,939.18 c 0,-30.668 -3.61,-58.301 -10.84,-82.91 -7.22,-24.61 -18.01,-45.559 -32.37,-62.848 -14.35,-17.281 -32.37,-30.563 -54.05,-39.844 -21.68,-9.277 -46.97,-13.906 -75.88,-13.906 -28.52,0 -53.17,4.238 -73.98,12.738 -20.8,8.5 -37.98,20.852 -51.56,37.059 -13.57,16.211 -23.68,36.332 -30.32,60.351 -6.64,24.02 -9.96,51.66 -9.96,82.91 0,29.879 3.61,57.032 10.84,81.45 7.23,24.41 18.07,45.16 32.52,62.25 14.45,17.09 32.52,30.28 54.2,39.55 21.68,9.28 46.97,13.92 75.88,13.92 27.93,0 52.24,-4.2 72.95,-12.6 20.7,-8.4 37.94,-20.65 51.7,-36.77 13.77,-16.11 24.03,-36.03 30.77,-59.76 6.73,-23.731 10.1,-50.93 10.1,-81.59 z m -53.32,-3.52 c 0,21.488 -1.9,41.461 -5.7,59.91 -3.81,18.46 -10.15,34.48 -19.02,48.05 -8.88,13.57 -20.73,24.17 -35.55,31.79 -14.83,7.61 -33.16,11.42 -55.01,11.42 -21.85,0 -40.18,-4.1 -55.01,-12.3 -14.82,-8.2 -26.87,-19.14 -36.13,-32.81 -9.27,-13.68 -15.9,-29.64 -19.9,-47.9 -4,-18.269 -6,-37.461 -6,-57.57 0,-22.27 1.85,-42.781 5.56,-61.531 3.71,-18.75 9.95,-34.91 18.73,-48.481 8.77,-13.578 20.53,-24.117 35.26,-31.636 14.72,-7.524 33.2,-11.282 55.44,-11.282 22.04,0 40.57,4.102 55.6,12.301 15.02,8.207 27.11,19.289 36.28,33.25 9.16,13.969 15.7,30.129 19.6,48.488 3.9,18.36 5.85,37.789 5.85,58.301",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path229",
    d: "m 2258.05,766.91 c 0,-3.512 -0.25,-6.64 -0.73,-9.371 -0.49,-2.738 -1.18,-5.027 -2.05,-6.891 -0.88,-1.847 -2.06,-3.218 -3.52,-4.097 -1.47,-0.879 -3.08,-1.321 -4.83,-1.321 h -209.48 c -2.73,0 -5.12,0.34 -7.17,1.032 -2.06,0.679 -3.81,1.797 -5.28,3.367 -1.46,1.562 -2.54,3.801 -3.22,6.73 -0.68,2.93 -1.03,6.551 -1.03,10.84 0,3.91 0.15,7.332 0.46,10.262 0.3,2.93 0.95,5.519 1.96,7.758 1,2.25 2.26,4.492 3.77,6.742 1.51,2.25 3.48,4.641 5.89,7.18 l 75.77,77.929 c 17.51,17.969 31.55,34.078 42.12,48.34 10.57,14.262 18.72,27.238 24.45,38.961 5.74,11.719 9.51,22.367 11.32,31.938 1.82,9.571 2.72,18.551 2.72,26.951 0,8.4 -1.41,16.36 -4.23,23.88 -2.82,7.52 -6.9,14.11 -12.24,19.77 -5.34,5.67 -12.05,10.16 -20.11,13.48 -8.06,3.32 -17.33,4.98 -27.81,4.98 -12.29,0 -23.32,-1.66 -33.1,-4.98 -9.77,-3.32 -18.34,-6.94 -25.7,-10.84 -7.35,-3.91 -13.5,-7.52 -18.43,-10.84 -4.94,-3.32 -8.62,-4.98 -11.04,-4.98 -1.41,0 -2.67,0.39 -3.78,1.17 -1.11,0.78 -2.01,2.05 -2.72,3.81 -0.7,1.76 -1.26,4.1 -1.66,7.03 -0.4,2.93 -0.6,6.44 -0.6,10.55 0,2.93 0.09,5.46 0.29,7.61 0.19,2.15 0.54,4.01 1.02,5.57 0.49,1.56 1.13,3.03 1.91,4.39 0.78,1.37 2.34,3.08 4.69,5.13 2.34,2.05 6.39,4.84 12.15,8.35 5.77,3.52 12.99,6.98 21.68,10.4 8.69,3.42 18.26,6.3 28.71,8.64 10.45,2.35 21.44,3.52 32.96,3.52 18.36,0 34.43,-2.59 48.2,-7.76 13.77,-5.18 25.19,-12.26 34.27,-21.24 9.09,-8.99 15.87,-19.44 20.37,-31.35 4.49,-11.92 6.73,-24.61 6.73,-38.09 0,-12.11 -1.07,-24.17 -3.22,-36.179 -2.15,-12.011 -6.69,-25 -13.62,-38.961 -6.94,-13.968 -16.95,-29.5 -30.03,-46.59 -13.09,-17.089 -30.47,-36.761 -52.15,-59.031 L 2081.68,788 h 164.94 c 1.57,0 3.08,-0.43 4.54,-1.309 1.47,-0.882 2.74,-2.203 3.81,-3.961 1.08,-1.761 1.86,-3.949 2.35,-6.589 0.48,-2.641 0.73,-5.711 0.73,-9.231",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path230",
    d: "m 2554.52,1102.65 c 0,-3.51 -0.15,-6.69 -0.44,-9.52 -0.3,-2.83 -0.69,-5.56 -1.17,-8.2 -0.49,-2.64 -1.18,-5.18 -2.06,-7.62 -0.87,-2.44 -1.9,-5.03 -3.07,-7.76 L 2411.25,754.898 c -0.97,-2.339 -2.19,-4.25 -3.66,-5.707 -1.46,-1.472 -3.32,-2.64 -5.56,-3.519 -2.25,-0.883 -5.13,-1.461 -8.65,-1.762 -3.51,-0.289 -7.81,-0.441 -12.89,-0.441 -6.64,0 -11.81,0.301 -15.52,0.883 -3.72,0.589 -6.4,1.519 -8.06,2.789 -1.66,1.269 -2.39,2.828 -2.2,4.679 0.2,1.86 0.88,4.059 2.05,6.602 l 143.56,321.668 h -181.94 c -3.71,0 -6.49,1.96 -8.35,5.86 -1.85,3.91 -2.78,9.38 -2.78,16.41 0,3.71 0.25,6.93 0.73,9.67 0.49,2.73 1.22,5.03 2.2,6.88 0.98,1.86 2.15,3.23 3.52,4.1 1.36,0.88 2.93,1.32 4.68,1.32 h 220.9 c 2.74,0 5.13,-0.29 7.18,-0.88 2.05,-0.58 3.61,-1.75 4.69,-3.51 1.07,-1.76 1.9,-4.01 2.49,-6.74 0.58,-2.73 0.88,-6.25 0.88,-10.55",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path231",
    d: "m 2852.45,935.66 c 0,-29.101 -2.3,-55.66 -6.89,-79.691 -4.59,-24.02 -12.2,-44.668 -22.85,-61.957 -10.64,-17.282 -24.56,-30.66 -41.75,-40.141 -17.18,-9.473 -38.37,-14.199 -63.57,-14.199 -23.83,0 -43.9,4.238 -60.2,12.738 -16.31,8.5 -29.45,21 -39.41,37.5 -9.96,16.5 -17.04,36.82 -21.24,60.942 -4.2,24.117 -6.3,51.796 -6.3,83.046 0,28.911 2.35,55.422 7.03,79.542 4.69,24.13 12.31,44.83 22.86,62.11 10.54,17.29 24.41,30.67 41.6,40.14 17.18,9.47 38.28,14.21 63.28,14.21 24.02,0 44.19,-4.25 60.5,-12.74 16.3,-8.5 29.44,-21 39.4,-37.5 9.96,-16.51 17.04,-36.82 21.24,-60.94 4.2,-24.118 6.3,-51.81 6.3,-83.06 z m -51.56,-3.512 c 0,18.942 -0.69,35.93 -2.05,50.973 -1.37,15.039 -3.37,28.319 -6.01,39.849 -2.64,11.52 -6.05,21.43 -10.25,29.73 -4.2,8.3 -9.23,15.14 -15.09,20.51 -5.86,5.37 -12.55,9.28 -20.07,11.72 -7.52,2.44 -15.97,3.66 -25.34,3.66 -16.6,0 -30.08,-3.91 -40.43,-11.72 -10.35,-7.81 -18.51,-18.55 -24.46,-32.22 -5.96,-13.68 -10.01,-29.69 -12.16,-48.048 -2.15,-18.364 -3.23,-38.09 -3.23,-59.18 0,-28.32 1.47,-52.391 4.4,-72.223 2.93,-19.82 7.57,-35.98 13.92,-48.48 6.34,-12.5 14.45,-21.59 24.31,-27.25 9.87,-5.66 21.83,-8.5 35.89,-8.5 10.94,0 20.56,1.761 28.86,5.281 8.3,3.512 15.43,8.539 21.38,15.078 5.96,6.551 10.89,14.41 14.8,23.594 3.91,9.18 7.03,19.328 9.37,30.469 2.35,11.129 3.96,23.187 4.84,36.179 0.88,12.989 1.32,26.508 1.32,40.578",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path232",
    d: "m 3143.35,935.66 c 0,-29.101 -2.29,-55.66 -6.88,-79.691 -4.59,-24.02 -12.21,-44.668 -22.86,-61.957 -10.64,-17.282 -24.56,-30.66 -41.74,-40.141 -17.19,-9.473 -38.38,-14.199 -63.58,-14.199 -23.83,0 -43.89,4.238 -60.2,12.738 -16.31,8.5 -29.45,21 -39.41,37.5 -9.96,16.5 -17.04,36.82 -21.24,60.942 -4.2,24.117 -6.3,51.796 -6.3,83.046 0,28.911 2.35,55.422 7.04,79.542 4.68,24.13 12.3,44.83 22.85,62.11 10.54,17.29 24.41,30.67 41.6,40.14 17.19,9.47 38.28,14.21 63.28,14.21 24.02,0 44.19,-4.25 60.5,-12.74 16.31,-8.5 29.44,-21 39.4,-37.5 9.96,-16.51 17.04,-36.82 21.24,-60.94 4.2,-24.118 6.3,-51.81 6.3,-83.06 z m -51.56,-3.512 c 0,18.942 -0.69,35.93 -2.05,50.973 -1.37,15.039 -3.37,28.319 -6.01,39.849 -2.63,11.52 -6.05,21.43 -10.25,29.73 -4.2,8.3 -9.23,15.14 -15.09,20.51 -5.86,5.37 -12.55,9.28 -20.07,11.72 -7.52,2.44 -15.97,3.66 -25.34,3.66 -16.6,0 -30.08,-3.91 -40.43,-11.72 -10.35,-7.81 -18.51,-18.55 -24.46,-32.22 -5.96,-13.68 -10.01,-29.69 -12.16,-48.048 -2.15,-18.364 -3.22,-38.09 -3.22,-59.18 0,-28.32 1.46,-52.391 4.39,-72.223 2.93,-19.82 7.57,-35.98 13.92,-48.48 6.34,-12.5 14.45,-21.59 24.31,-27.25 9.87,-5.66 21.83,-8.5 35.89,-8.5 10.94,0 20.56,1.761 28.86,5.281 8.3,3.512 15.43,8.539 21.39,15.078 5.95,6.551 10.88,14.41 14.79,23.594 3.91,9.18 7.03,19.328 9.38,30.469 2.34,11.129 3.95,23.187 4.83,36.179 0.88,12.989 1.32,26.508 1.32,40.578",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path233",
    d: "m 3422.53,765.148 c 0,-3.707 -0.29,-6.828 -0.88,-9.367 -0.58,-2.543 -1.36,-4.59 -2.34,-6.152 -0.98,-1.57 -2.1,-2.688 -3.37,-3.367 -1.27,-0.692 -2.59,-1.032 -3.95,-1.032 h -198.05 c -1.37,0 -2.64,0.34 -3.81,1.032 -1.17,0.679 -2.29,1.797 -3.37,3.367 -1.07,1.562 -1.9,3.609 -2.49,6.152 -0.58,2.539 -0.88,5.66 -0.88,9.367 0,3.524 0.3,6.551 0.88,9.09 0.59,2.532 1.32,4.633 2.2,6.293 0.88,1.66 1.95,2.93 3.22,3.809 1.27,0.879 2.69,1.32 4.25,1.32 h 79.1 v 288.28 l -73.24,-43.65 c -3.71,-1.95 -6.69,-3.12 -8.94,-3.52 -2.24,-0.39 -4.05,0.05 -5.42,1.32 -1.36,1.27 -2.29,3.37 -2.78,6.3 -0.49,2.93 -0.73,6.64 -0.73,11.13 0,3.32 0.14,6.16 0.44,8.5 0.29,2.34 0.73,4.3 1.32,5.86 0.58,1.56 1.41,2.93 2.49,4.1 1.07,1.17 2.49,2.35 4.24,3.52 l 87.31,55.95 c 0.78,0.59 1.76,1.08 2.93,1.47 1.17,0.39 2.64,0.78 4.39,1.17 1.76,0.39 3.81,0.64 6.16,0.73 2.34,0.1 5.27,0.15 8.78,0.15 4.69,0 8.6,-0.2 11.72,-0.59 3.13,-0.39 5.57,-0.92 7.33,-1.61 1.76,-0.68 2.93,-1.56 3.51,-2.63 0.59,-1.08 0.88,-2.2 0.88,-3.37 V 785.66 h 68.56 c 1.56,0 3.02,-0.441 4.39,-1.32 1.37,-0.879 2.49,-2.149 3.37,-3.809 0.88,-1.66 1.56,-3.761 2.05,-6.293 0.49,-2.539 0.73,-5.566 0.73,-9.09",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,604.72)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsoCert);
export default __webpack_public_path__ + "static/media/iso-cert.e85a523092de48cc3adec6cefa94e4c0.svg";
export { ForwardRef as ReactComponent };